import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import {
	checkLocalSavedData,
	destroyIndicator,
	destroyTooltip,
	destroyTooltip02,
	displayIndicator,
	displayTooltip,
	displayTooltip02,
	loadUserCreatureDataLocally,
	saveUserCreatureDataLocally,
	playUISound,
	playNotificationAnimation,
	playTickAnimation,
	displayTutorialHand,
	playErrorAnimation,
	playTabletUnlockAnimations
} from "../helpers/levelManager"
import { createTopBar } from "../helpers/levelManager"
import { updateMiniLevel } from "../helpers/levelManager"
import { handleGameProgressUpdate } from "../helpers/levelManager"
import { phaserOverlay, htmlOverlay } from "../helpers/planetBlocker"

export default class CreatureDatabase extends Phaser.Scene {
	constructor() {
		super({ key: "CreatureDatabase" })
	}

	init() {
		// Initialize core properties
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		// Get scaling information
		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.templateY = scalingData.templateY

		//this.showTabletBool = false

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		// UI state flags
		this.detailViewOpen = false
		this.detailsTabActive = true
		this.activityTabActive = false
		this.selectedCreatureIndex = null
		this.closeDetailsBool = false
		this.keepCheking = true

		// Load creature data
		this.loadCreatureData()
	}

	loadCreatureData() {
		this.creatureData = this.cache.json.get("creatureData")
		this.savedUserData = checkLocalSavedData()
		this.creatureDatabase = this.savedUserData.creaturesDischarged
		this.creaturesUnlocked = this.savedUserData.creaturesUnlocked
		console.log("Discharged " + this.creatureDatabase)

		this.userData = checkLocalSavedData()
		this.savedLevel = this.userData === null ? 0 : this.userData.userLevel
		this.savedMiniLevel =
			this.userData === null ? 0 : this.userData.userMiniLevel
		this.currentPlanet =
			this.userData === null ? 0 : this.userData.currentPlanet
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager
		this.createBackground()
		this.createAppBar()
		this.createGalleryView()
		createTopBar(this)
		this.cleanupScene()

		if (this.currentPlanet === 3) {
			this.zoomInTutorial = false
			this.zoomTotalTutorial = false
		}
	}

	createBackground() {
		this.fieldBackground = this.add
			.image(this.gameW / 2, this.gameH / 2, "spaceBG")
			.setScale((this.scaleFactor * 0.601) * 0.25, (this.scaleFactor * 0.49) * 0.25)
	}

	createAppBar() {
		// App bar background
		this.appBar = this.add
			.image(
				this.gameW / 2,
				this.gameH / 2 - 125 * this.scaleFactor,
				"dbAppBar",
			)
			.setScale(this.scaleFactor)

		// App bar title
		this.appBarText = this.add
			.text(this.appBar.x, this.appBar.y, "Database", {
				fontFamily: "Gluten",
				fontSize: this.fontSize + 4 * this.scaleFactor,
				color: "white",
				align: "left",
				resolution: 2,
			})
			.setOrigin(0.5)

		// Close button
		this.createCloseButton()

		// Back button
		this.createBackButton()
	}

	createCloseButton() {
		const closeButton = this.add.image(
			this.appBar.x + 230 * this.scaleFactor,
			this.appBar.y,
			"appCloseButton",
		).setScale(this.scaleFactor * 0.5)

		closeButton.setInteractive().on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			destroyTooltip(this)
			this.cleanupScene()
			this.entryCount = 1
			this.scene.stop("CreatureDatabase")
			this.scene.resume("TabletScene")
		})

		return closeButton
	}

	createBackButton() {
		this.backButton = this.add
			.image(
				this.appBar.x - 230 * this.scaleFactor,
				this.appBar.y,
				"appBackButton",
			)
			.setVisible(false)
			.setScale(this.scaleFactor * 0.5)

		this.backButton.setInteractive().on("pointerdown", () => {
			console.log("Back button pressed...........")
			if (this.planetNamePill) {
				this.planetNamePill.setVisible(true)
			}

			if (this.planetNameText) {
				this.planetNameText.setVisible(true)
			}
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			destroyTooltip(this)
			destroyTooltip02(this)
			this.backButton.setVisible(false)

			this.entryCount = 1

			this.galleryViewGroup.clear(true, true)

			this.createGalleryView()

			this.detailsTabActive = true
			this.tabHolder.setVisible(false)
			this.detailsTab.setVisible(false)
			this.activityTab.setVisible(false)
			if (this.activityNotificationBell) {
				this.activityNotificationBell.setVisible(false)
			}
			if (this.activityBackGround) {
				this.activityBackGround.setVisible(false)
			}
			if (this.fedPill) {
				this.fedPill.setVisible(false)
			}
			if (this.fedPillText) {
				this.fedPillText.setVisible(false)
			}
			if (this.saveActivityButton) {
				this.saveActivityButton.destroy()
			}
			if (this.saveActivityText) {
				this.saveActivityText.destroy()
			}
			if (this.addEntry) {
				this.addEntry.setVisible(false)
			}
			if (this.addEntryText) {
				this.addEntryText.setVisible(false)
			}
			if (this.pillDate) {
				this.pillDate.setVisible(false)
			}

			if (this.savedMiniLevel >= 3) {
				console.log("Set Activity Tab Active")
				this.activityTabActive = true
			}

			if (this.closeDetailsBool) {
			} else {
			}

			// Remove all HTML elements
			this.removeScrollPanel()

			// Make sure these are removed if they exist
			if (this.dropdownElement) this.dropdownElement.remove()
			if (this.numberInputElement) this.numberInputElement.remove()
			if (this.requiredTextElement) this.requiredTextElement.remove()
			if (this.dropdownElement2) this.dropdownElement2.remove()
			if (this.numberInputElement2) this.numberInputElement2.remove()
			if (this.requiredTextElement2) this.requiredTextElement2.remove()
			if (this.addEntry) this.addEntry.destroy()
			if (this.addEntryText) this.addEntryText.destroy()

			// Remove any other HTML elements that might have been created
			const styles = document.getElementById("creature-form-styles")
			if (styles) styles.remove()
		})
	}

	createGalleryView() {
		this.detailViewOpen = false
		this.galleryViewGroup = this.add.group()

		// Add close button to gallery group
		this.galleryViewGroup.add(this.createCloseButton())

		// if (this.planetNamePill) {
		// 	this.planetNamePill.setVisible(true)
		// }

		// if (this.planetNameText) {
		// 	this.planetNameText.setVisible(true)
		// }

		let totalCreatures

		if (this.currentPlanet === 1) {
			totalCreatures = 2
		} else {
			totalCreatures = 3
		}

		let planetName

		let creatureIndices = []
		if (this.currentPlanet === 1) {
			creatureIndices = [1, 2]
			planetName = "Hypotherra"
		} else if (this.currentPlanet === 2) {
			creatureIndices = [3, 4, 5]
			planetName = "Stratosoma"
		} else if (this.currentPlanet === 3) {
			creatureIndices = [6, 7, 8]
			planetName = "Emberon"
		}

		const numRows = 2
		const numCols = Math.min(totalCreatures, 4)
		const containerSpacingX = 155 * this.scaleFactor
		const containerSpacingY = 125 * this.scaleFactor
		const initialOffsetX = this.fieldBackground.x / 2 + 60 * this.scaleFactor
		const initialOffsetY = this.fieldBackground.y + 10 * this.scaleFactor

		for (let row = 0; row < numRows; row++) {
			for (let col = 0; col < numCols; col++) {
				const creatureIndex = row * numCols + col + 1
				let index = creatureIndices[creatureIndex - 1]
				if (creatureIndex <= totalCreatures) {
					this.createCreatureItem(
						index,
						initialOffsetX + col * containerSpacingX,
						initialOffsetY + row * containerSpacingY,
					)
				}
			}
		}

		this.planetNamePill = this.add.image(
			this.fieldBackground.x / 2 + 55 * this.scaleFactor,
			this.gameH / 2 - 85 * this.scaleFactor,
			"PlanetNamePill"
		).setScale(this.scaleFactor * 0.34)

		this.planetNameText = this.add.text(
			this.planetNamePill.x + 5 * this.scaleFactor,
			this.planetNamePill.y - 8 * this.scaleFactor,
			planetName, {
			fontSize: Math.round(this.fontSize - 7 * this.scaleFactor) + "px",
			fill: "#11044E",
			align: "center",
			fontFamily: '"Space Grotesk", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})

		this.galleryViewGroup.add(this.planetNamePill)
		this.galleryViewGroup.add(this.planetNameText)
	}

	createCreatureItem(creatureIndex, posX, posY) {
		// Determine creature status
		let isUnlocked = this.creaturesUnlocked.includes(creatureIndex)
		let isDischarged = this.creatureDatabase.includes(creatureIndex)
		let notificationBell
		console.log("Discharged " + this.creatureDatabase)
		let isActive = isUnlocked && !isDischarged
		console.log(
			"MiniLevel: " +
			this.savedMiniLevel +
			", creatureIndex: " +
			creatureIndex +
			", isActive: " +
			isActive +
			", isDischarged: " +
			isDischarged +
			"isUnlocked: " +
			isUnlocked,
		)
		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel <= 3 && creatureIndex === 1) {
				isActive = true
				isDischarged = false
			}
			if (this.savedMiniLevel <= 5 && creatureIndex === 2) {
				isActive = false
				isDischarged = false
			}
			if (this.savedMiniLevel >= 6 && creatureIndex === 2) {
				isActive = true
				isDischarged = false
			}
		}
		if (this.currentPlanet === 2) {
			console.log("Creature Index == " + creatureIndex)
			if (this.savedMiniLevel <= 3 && creatureIndex === 3) {
				isActive = true
				isDischarged = false
			} else if (creatureIndex === 3) {
				isDischarged = true
			}
			if (this.savedMiniLevel < 6 && creatureIndex === 4) {
				isActive = false
				isDischarged = false
			} else if (this.savedMiniLevel <= 10 && creatureIndex === 4) {
				isActive = true
				isDischarged = false
			} else if (creatureIndex === 4) {
				isDischarged = true
			}
			if (this.savedMiniLevel <= 12 && creatureIndex === 5) {
				isActive = false
				isDischarged = false
			} else if (this.savedMiniLevel <= 18 && creatureIndex === 5) {
				console.log("TabletBool: " + this.showTabletBool)
				if (this.showTabletBool) {
					isActive = true
					isDischarged = false
				} else {
					isActive = false
					isDischarged = false
				}
			} else if (creatureIndex === 5) {
				isDischarged = true
			}
		}
		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel < 2 && creatureIndex === 6) {
				isActive = false
				isDischarged = false
			} else if (
				this.savedMiniLevel >= 2 &&
				this.savedMiniLevel <= 7 &&
				creatureIndex === 6
			) {
				isActive = true
				isDischarged = false
			} else if (creatureIndex === 6) {
				isDischarged = true
			}
			if (this.savedMiniLevel < 10 && creatureIndex === 7) {
				isActive = false
				isDischarged = false
			} else if (
				this.savedMiniLevel >= 10 &&
				this.savedMiniLevel <= 15 &&
				creatureIndex === 7
			) {
				isActive = true
				isDischarged = false
			} else if (creatureIndex === 7) {
				isDischarged = true
			}
			if (this.savedMiniLevel <= 17 && creatureIndex === 8) {
				isActive = false
				isDischarged = false
			} else if (
				this.savedMiniLevel >= 18 &&
				this.savedMiniLevel <= 21 &&
				creatureIndex === 8
			) {
				isActive = true
				isDischarged = false
			} else if (creatureIndex === 8) {
				isDischarged = true
			}
		}
		// Select appropriate texture based on status
		let textureSuffix
		if (isActive) {
			textureSuffix = "_GalleryActive"
		} else if (isDischarged) {
			textureSuffix = "_GalleryDischarged"
		} else {
			textureSuffix = "_GalleryLocked"
		}

		const creatureHolder = this.add
			.image(posX, posY + 10 * this.scaleFactor, "appHolder")
			.setScale(this.scaleFactor * 0.5)

		// Create creature with appropriate texture
		const creature = this.add
			.image(posX, posY, `creature0${creatureIndex}${textureSuffix}`)
			.setScale(this.scaleFactor * 0.5)
		const creatureDat = this.creatureData.creatures.find(
			({ index }) => index === creatureIndex,
		)
		let creatureNameString = creatureDat ? creatureDat.name : "Your creature"

		if (!isDischarged && !isActive) {
			creatureNameString = "???"
		}

		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 1 && creatureIndex === 1) {
				playTabletUnlockAnimations(this,
					{
						xPos: creature.x,
						yPos: creature.y + 10 * this.scaleFactor
					}
				)
			}
			if (this.savedMiniLevel === 6 && creatureIndex === 2) {
				playTabletUnlockAnimations(this,
					{
						xPos: creature.x,
						yPos: creature.y + 10 * this.scaleFactor
					}
				)
			}
		}
		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel === 1 && creatureIndex === 3) {
				playTabletUnlockAnimations(this,
					{
						xPos: creature.x,
						yPos: creature.y + 10 * this.scaleFactor
					}
				)
			}
			if (this.savedMiniLevel === 6 && creatureIndex === 4) {
				playTabletUnlockAnimations(this,
					{
						xPos: creature.x,
						yPos: creature.y + 10 * this.scaleFactor
					}
				)
			}
			if (this.savedMiniLevel === 13 && creatureIndex === 5) {
				console.log("TabletBool: " + this.showTabletBool)
				if (this.showTabletBool) {
					playTabletUnlockAnimations(this,
						{
							xPos: creature.x,
							yPos: creature.y + 10 * this.scaleFactor
						}
					)
				} else {

				}
			}
		}
		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel === 3 && creatureIndex === 6) {
				playTabletUnlockAnimations(this,
					{
						xPos: creature.x,
						yPos: creature.y + 10 * this.scaleFactor
					}
				)
			}
			if (this.savedMiniLevel === 10 && creatureIndex === 7) {
				playTabletUnlockAnimations(this,
					{
						xPos: creature.x,
						yPos: creature.y + 10 * this.scaleFactor
					}
				)
			}
			if (this.savedMiniLevel === 18 && creatureIndex === 8) {
				playTabletUnlockAnimations(this,
					{
						xPos: creature.x,
						yPos: creature.y + 10 * this.scaleFactor
					}
				)
			}
		}
		const creatureName = this.add
			.text(
				creature.x - 1 * this.scaleFactor,
				creature.y + 63 * this.scaleFactor,
				creatureNameString,
				{
					fontFamily: "Gluten",
					fontSize: this.fontSize - 4 * this.scaleFactor,
					color: "#11044E",
					fontStyle: "bold",
					fontWeight: "700",
					align: "center",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
		if (isDischarged) {
			creature.setInteractive()
			creature.on("pointerdown", () => {
				return
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)

				if (this.creatureOverlayReference) {
					this.creatureOverlayReference.remove()
				}
				if (this.tooltip) {
					this.tooltip.destroy()
				}
				if (this.tooltipText) {
					this.tooltipText.destroy()
				}
				if (this.tutorialHand) {
					this.tutorialHand.destroy()
				}
				if (notificationBell) {
					notificationBell.destroy()
					console.log("Notification Bell Destroyed")
				}

				if (!this.detailViewOpen) {

					this.detailViewOpen = true
					this.selectedCreatureIndex = creatureIndex
					this.galleryViewGroup.setVisible(false)
					this.openDetailView(creatureIndex, isDischarged)
					destroyIndicator(this)
				}
			})
		}
		// Add interactivity only to active creatures
		else if (isActive) {

			// notificationBell = this.add
			// 	.image(
			// 		creature.x + 50 * this.scaleFactor,
			// 		creature.y - 50 * this.scaleFactor,
			// 		"notificationBell",
			// 	)
			// 	.setOrigin(0.5)
			// 	.setScale(this.scaleFactor / 2)
			// 	.setDepth(2)

			playNotificationAnimation(this,
				{
					xPos: creature.x + 50 * this.scaleFactor,
					yPos: creature.y - 50 * this.scaleFactor
				}
			)
			if (this.currentPlanet === 1) {
				console.log("Creature INDICATOR")
				if (this.savedMiniLevel <= 2 && creatureIndex === 1) {
					// displayIndicator(
					// 	this,
					// 	creature.x,
					// 	creature.y + 10 * this.scaleFactor,
					// 	1,
					// 	"tabAppIndicator",
					// )

					playNotificationAnimation(this,
						{
							xPos: creature.x + 50 * this.scaleFactor,
							yPos: creature.y - 50 * this.scaleFactor
						}
					)


					displayTooltip(this, {
						xPos: creature.x - 150 * this.scaleFactor,
						yPos: creature.y,
						type: "creatureDetailsTip",
						scale: 1,
						text: "Press to see\nthe creature details",
						fontScale: -8,
						xTextOffset: -3,
						yTextOffset: 1,
						wrapWidth: 0.8,
					})

					displayTutorialHand(this, {
						xPos: creature.x - 110 * this.scaleFactor,
						yPos: creature.y + 45 * this.scaleFactor,
						rotation: 70,
					})

					const overlay = phaserOverlay(this)
					overlay.setTargetByCoords(
						creature.x - creature.width * this.scaleFactor * 0.4,
						creature.y - creature.height * this.scaleFactor * 0.4,
						creature.width * this.scaleFactor * 0.8,
						creature.height * this.scaleFactor * 0.8,
					)

					overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.tutorialHand])

					this.creatureOverlayReference = overlay

					console.log("Creature Overlay and Tooltip")
				}

				if (this.savedMiniLevel === 3) {
					playNotificationAnimation(this,
						{
							xPos: creature.x + 50 * this.scaleFactor,
							yPos: creature.y - 50 * this.scaleFactor
						}
					)

					const overlay = phaserOverlay(this)
					overlay.setTargetByCoords(
						creature.x - creature.width * this.scaleFactor * 0.4,
						creature.y - creature.height * this.scaleFactor * 0.4,
						creature.width * this.scaleFactor * 0.8,
						creature.height * this.scaleFactor * 0.8,
					)



					this.creatureOverlayReference = overlay

					displayTutorialHand(this, {
						xPos: creature.x - 110 * this.scaleFactor,
						yPos: creature.y + 45 * this.scaleFactor,
						rotation: 70,
					})

					overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.tutorialHand])
				}

				if (this.savedMiniLevel === 6 && creatureIndex === 2) {
					// displayIndicator(
					// 	this,
					// 	creature.x,
					// 	creature.y + 10 * this.scaleFactor,
					// 	1,
					// 	"tabAppIndicator",
					// )

					displayTutorialHand(this, {
						xPos: creature.x - 110 * this.scaleFactor,
						yPos: creature.y + 45 * this.scaleFactor,
						rotation: 70,
					})
				}

				if (this.savedMiniLevel === 8 && creatureIndex === 2) {
					displayTutorialHand(this, {
						xPos: creature.x - 110 * this.scaleFactor,
						yPos: creature.y + 45 * this.scaleFactor,
						rotation: 70,
					})
				}

				if (this.savedMiniLevel === 9 && creatureIndex === 2) {
					displayTutorialHand(this, {
						xPos: creature.x - 90 * this.scaleFactor,
						yPos: creature.y - 100 * this.scaleFactor,
						rotation: 145,
					})
				}
			}
			if (this.currentPlanet === 2) {
				console.log("Creature INDICATOR")
				if (this.savedMiniLevel <= 3 && creatureIndex === 3) {
					displayIndicator(
						this,
						creature.x,
						creature.y + 10 * this.scaleFactor,
						1,
						"tabAppIndicator",
					)

					displayTutorialHand(this, {
						xPos: creature.x - 110 * this.scaleFactor,
						yPos: creature.y + 45 * this.scaleFactor,
						rotation: 70,
					})

				}
				if (this.savedMiniLevel === 6 && creatureIndex === 4) {
					displayIndicator(
						this,
						creature.x,
						creature.y + 10 * this.scaleFactor,
						1,
						"tabAppIndicator",
					)
				}

				if (this.savedMiniLevel === 9 && creatureIndex === 4) {
					displayIndicator(
						this,
						creature.x,
						creature.y + 10 * this.scaleFactor,
						1,
						"tabAppIndicator",
					)
				}

				if (this.savedMiniLevel === 13 && creatureIndex === 5) {
					displayIndicator(
						this,
						creature.x,
						creature.y + 10 * this.scaleFactor,
						1,
						"tabAppIndicator",
					)
				}
			}
			creature.setInteractive()
			creature.on("pointerdown", () => {
				console.log("Creature Pressed.................")
				if (this.planetNamePill) {
					this.planetNamePill.setVisible(false)
				}

				if (this.planetNameText) {
					this.planetNameText.setVisible(false)
				}
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				if (!this.detailViewOpen) {
					if (notificationBell) {
						notificationBell.destroy()
						console.log("Notification Bell Destroyed")
					}
					if (this.tutorialHand) {
						this.tutorialHand.destroy()
					}
					this.detailViewOpen = true
					this.selectedCreatureIndex = creatureIndex
					this.dischargedState = isDischarged
					this.galleryViewGroup.setVisible(false)
					this.openDetailView(creatureIndex)
					//destroyIndicator(this)
					if (this.currentPlanet === 1) {
						if (this.savedMiniLevel < 3 && creatureIndex === 1) {
							// displayTooltip(
							// 	this,
							// 	this.gameW / 2 + 325 * this.scaleFactor,
							// 	this.gameH / 2 + 50 * this.scaleFactor,
							// 	"small",
							// 	"Right",
							// 	"Scroll down to read and fill in any missing information in the database",
							// 	12,
							// )
							displayTooltip(this, {
								xPos: this.gameW / 2 + 325 * this.scaleFactor,
								yPos: this.gameH / 2 - 50 * this.scaleFactor,
								type: "mediumChunkyLeftTip",
								scale: 1.2,
								text: "Scroll down to\nfill in any\n[b]missing[/b] information",
								fontScale: -8,
								xTextOffset: 3,
								yTextOffset: 1,
								wrapWidth: 1.5,
							})

							// displayTooltip02(this, {
							// 	xPos: this.gameW / 2 + 325 * this.scaleFactor,
							// 	yPos: this.gameH / 2 + 100 * this.scaleFactor,
							// 	type: "mediumChunkyLeftTip",
							// 	scale: 1.3,
							// 	text: "Don't forget to press\n'Save'\nwhen you are done\nin order to continue.",
							// 	fontScale: -8,
							// 	xTextOffset: 3,
							// 	yTextOffset: 1,
							// 	wrapWidth: 1.5,
							// })

							if (!this.anims.exists('scrollAnim')) {
								this.anims.create({
									key: 'scrollAnim',
									frames: this.anims.generateFrameNames('scrollIndicator', {
										prefix: 'scrollIndicator_',
										start: 1,
										end: 75,
										zeroPad: 3,
										suffix: '.png'
									}),
									frameRate: 30,
									repeat: -1
								});
							}

							this.scrollAnim = this.add.sprite(
								this.gameW / 2 + 350 * this.scaleFactor,
								this.gameH / 2 + 100 * this.scaleFactor,
								'scrollIndicator',
								'scrollIndicator_001.png'
							)
								.setOrigin(0.5)
								.setScale(this.scaleFactor)

							this.scrollAnim.play('scrollAnim')

							if (this.creatureOverlayReference) {
								this.creatureOverlayReference.remove()
							}

							const overlay = phaserOverlay(this)
							const maskWidth = this.gameW - 350 * this.scaleFactor;
							const maskHeight = this.gameH - 120 * this.scaleFactor;

							overlay.setTargetByCoords(
								(this.gameW / 2) - (maskWidth / 2) + 10000,  // Center X minus half width
								(this.gameH / 2) - (maskHeight / 2) + 40 * this.scaleFactor, // Center Y minus half height
								maskWidth,
								maskHeight
							);

							overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.scrollAnim])

							this.detailsOverlayRef = overlay
						}

						if (this.savedMiniLevel === 6 && creatureIndex === 2) {
							// displayTooltip(
							// 	this,
							// 	this.gameW / 2 + 325 * this.scaleFactor,
							// 	this.gameH / 2 + 120 * this.scaleFactor,
							// 	"small",
							// 	"Right",
							// 	"This creature needs a barcode. Press to the button to generate one",
							// 	12,
							// )

							displayTooltip(this, {
								xPos: this.gameW / 2 + 325 * this.scaleFactor,
								yPos: this.gameH / 2 + 120 * this.scaleFactor,
								type: "mediumChunkyLeftTip",
								scale: 1,
								text: "This creature needs\na barcode. Press the\n[b]‘Generate’[/b] button\nto create one",
								fontScale: -8,
								xTextOffset: 3,
								yTextOffset: 1,
								wrapWidth: 1.01,
							})
						}
					}

					if (this.currentPlanet === 2) {
						if (this.savedMiniLevel < 3 && creatureIndex === 3) {
							// displayTooltip(
							// 	this,
							// 	this.gameW / 2 + 325 * this.scaleFactor,
							// 	this.gameH / 2 + 5 * this.scaleFactor,
							// 	"small",
							// 	"Right",
							// 	"It seems the barcode and creature code do not match. Scroll down to correct it.",
							// 	12,
							// )
							let wrapWidth = 0
							if (
								this.sys.game.device.os.desktop ||
								this.sys.game.device.os.laptop
							) {
								wrapWidth = 1.8
							} else {
								wrapWidth = 0.9
							}
							displayTooltip(this, {
								xPos: this.gameW / 2 + 335 * this.scaleFactor,
								yPos: this.gameH / 2 + 5 * this.scaleFactor,
								type: "barcodeMatchTip",
								scale: 1,
								text: "The [b]barcode[/b]\nand [b]creature code[/b]\naren’t the same.\n[b]Scroll down[/b] to fix this.",
								fontScale: -8,
								xTextOffset: 3,
								yTextOffset: 1.5,
								wrapWidth: wrapWidth,
							})
							// displayTooltip02(this, {
							// 	xPos: this.gameW / 2 + 335 * this.scaleFactor,
							// 	yPos: this.gameH / 2 + 130 * this.scaleFactor,
							// 	type: "pressTheDropDownTip",
							// 	scale: 1,
							// 	text: "Press the [b]dropdown[/b]\nto see a list of\noptions to\nchoose from.",
							// 	fontScale: -8,
							// 	xTextOffset: 3,
							// 	yTextOffset: 1.5,
							// 	wrapWidth: wrapWidth,
							// })
						}

						if (this.savedMiniLevel === 6 && creatureIndex === 4) {
							displayTooltip(
								this,
								this.gameW / 2 + 325 * this.scaleFactor,
								this.gameH / 2 + 50 * this.scaleFactor,
								"small",
								"Right",
								"Scroll down and select the correct planet name from the list.",
								12,
							)
						}

						if (creatureIndex === 3) {
							if (this.savedMiniLevel > 5) {
								this.activityTab.input.enabled = false
								this.activityTab.alpha = 0.5
							}
						}

						if (creatureIndex === 4) {
							if (this.savedMiniLevel > 13) {
								this.activityTab.input.enabled = false
								this.activityTab.alpha = 0.5
							}
						}


						if (this.savedMiniLevel === 13) {
							displayTooltip(
								this,
								this.gameW / 2 + 325 * this.scaleFactor,
								this.gameH / 2 + 50 * this.scaleFactor,
								"small",
								"Right",
								"Enter the date and time shown at the top of your tablet’s screen",
								12,
							)
						}
					}

					if (this.currentPlanet === 3) {


						if (this.savedMiniLevel <= 3 && creatureIndex === 6) {
							console.log(
								"Display tooltip for Creature " +
								creatureIndex +
								"minilevel " +
								this.savedMiniLevel,
							)
							let wrapWidth = 0
							if (
								this.sys.game.device.os.desktop ||
								this.sys.game.device.os.laptop
							) {
								wrapWidth = 1
							} else {
								wrapWidth = 1
							}
							displayTooltip(this, {
								xPos: 100 * this.scaleFactor,
								yPos: this.gameH / 2 + 5 * this.scaleFactor,
								type: "zoomTip",
								scale: 1,
								text: "Press the \n‘[img=zoomBtn]’ button\nto make the\nimage [b]bigger[/b]",
								fontScale: -7,
								xTextOffset: -5,
								yTextOffset: 0.5,
								wrapWidth: 1,
								images: {
									zoomBtn: {
										key: "zoomBtn",
										width: 20 * this.scaleFactor,
										height: 20 * this.scaleFactor,
									}
								}
							})
						}

						if (this.savedMiniLevel === 10) {
							displayTooltip(this, {
								xPos: this.gameW / 2 + 345 * this.scaleFactor,
								yPos: this.gameH / 2 - 50 * this.scaleFactor,
								type: "mediumChunkyLeftTip",
								scale: 1.2,
								text: "There seems to be a\nproblem with the barcode.\nPress '[b]click here[/b]'\nto resolve",
								fontScale: -8,
								xTextOffset: 3,
								yTextOffset: 1,
								wrapWidth: 1.5,
							})
						}
					}
				}
			})
		}

		// Add discharged icon for released creatures
		if (isDischarged) {
		}

		this.galleryViewGroup.add(creature)
		this.galleryViewGroup.add(creatureHolder)
		this.galleryViewGroup.add(creatureName)
	}

	openDetailView(creatureIndex, isDischarged) {
		this.createTabs()
		this.createDetailScroll(creatureIndex, isDischarged)
	}

	createTabs() {
		destroyIndicator(this)

		this.tabHolder = this.add
			.image(this.appBar.x, this.appBar.y + 60 * this.scaleFactor, "tabsHolder")
			.setScale(this.scaleFactor)
			.setOrigin(0.5)

		// Details tab (starts active)
		this.detailsTab = this.add
			.image(
				this.tabHolder.x / 2 + 24 * this.scaleFactor,
				this.tabHolder.y + 8 * this.scaleFactor,
				"detailsActive",
			)
			.setScale(this.scaleFactor * 0.3)
			.setInteractive()

		// Activity tab (starts inactive)
		this.activityTab = this.add
			.image(
				this.detailsTab.x + 115 * this.scaleFactor,
				this.tabHolder.y + 8 * this.scaleFactor,
				"activityInactive",
			)
			.setScale(this.scaleFactor * 0.3)
			.setInteractive()

		if (this.currentPlanet === 1) {
			this.activityTab.input.enabled = false
			this.activityTab.alpha = 0.5

			if (this.savedMiniLevel === 3) {
				this.activityTab.input.enabled = true
				this.activityTab.alpha = 1

				// this.activityNotificationBell = this.add
				// 	.image(
				// 		this.activityTab.x + 50 * this.scaleFactor,
				// 		this.activityTab.y - 25 * this.scaleFactor,
				// 		"notificationBell",
				// 	)
				// 	.setOrigin(0.5)
				// 	.setScale(this.scaleFactor / 2)
				// 	.setDepth(10)

				displayTooltip(this, {
					xPos: this.activityTab.x + 150 * this.scaleFactor,
					yPos: this.activityTab.y - 1 * this.scaleFactor,
					type: "tabletTip",
					scale: 0.8,
					text: "Press the\n[b]‘Activity Log’[/b] tab",
					fontScale: -8,
					xTextOffset: 3,
					yTextOffset: 1,
					wrapWidth: 0.8,
				})

				playNotificationAnimation(this,
					{
						xPos: this.activityTab.x + 50 * this.scaleFactor,
						yPos: this.activityTab.y - 25 * this.scaleFactor
					}
				)
				if (this.creatureOverlayReference) {
					this.creatureOverlayReference.remove()
				}


				const overlay = phaserOverlay(this);

				const button = this.activityTab

				overlay.setTargetByCoords(
					this.activityTab.x - button.width * this.scaleFactor * 0.2,
					this.activityTab.y - button.height * this.scaleFactor * 0.2,
					button.width * this.scaleFactor * 0.4,
					button.height * this.scaleFactor * 0.4,
					15
				)

				overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.notificationBell])

				this.activityOverlayRef = overlay
				// displayIndicator(
				// 	this,
				// 	this.activityTab.x,
				// 	this.activityTab.y,
				// 	1,
				// 	"tabsIndicator",
				// )
			}

			if (this.savedMiniLevel === 9) {
				this.activityTab.input.enabled = true
				this.activityTab.alpha = 1

				// this.activityNotificationBell = this.add
				// 	.image(
				// 		this.activityTab.x + 50 * this.scaleFactor,
				// 		this.activityTab.y - 25 * this.scaleFactor,
				// 		"notificationBell",
				// 	)
				// 	.setOrigin(0.5)
				// 	.setScale(this.scaleFactor / 2)
				// 	.setDepth(10)

				playNotificationAnimation(this,
					{
						xPos: this.activityTab.x + 50 * this.scaleFactor,
						yPos: this.activityTab.y - 25 * this.scaleFactor
					}
				)

				displayTutorialHand(this, {
					xPos: this.activityTab.x + 105 * this.scaleFactor,
					yPos: this.activityTab.y - 1 * this.scaleFactor,
					rotation: -90,
				})
			}
		}

		if (this.currentPlanet === 2) {
			this.activityTab.input.enabled = false
			this.activityTab.alpha = 0.5

			if (this.savedMiniLevel === 3) {
				this.activityTab.input.enabled = true
				this.activityTab.alpha = 1

				// this.activityNotificationBell = this.add
				// 	.image(
				// 		this.activityTab.x + 50 * this.scaleFactor,
				// 		this.activityTab.y - 25 * this.scaleFactor,
				// 		"notificationBell",
				// 	)
				// 	.setOrigin(0.5)
				// 	.setScale(this.scaleFactor / 2)
				// 	.setDepth(10)

				// displayIndicator(
				// 	this,
				// 	this.activityTab.x,
				// 	this.activityTab.y,
				// 	1,
				// 	"tabsIndicator",
				// )
				playNotificationAnimation(this,
					{
						xPos: this.activityTab.x + 50 * this.scaleFactor,
						yPos: this.activityTab.y - 25 * this.scaleFactor
					}
				)
			}


			if (this.savedMiniLevel === 9 || this.savedMiniLevel === 16) {
				this.activityTab.input.enabled = true
				this.activityTab.alpha = 1

				// this.activityNotificationBell = this.add
				// 	.image(
				// 		this.activityTab.x + 50 * this.scaleFactor,
				// 		this.activityTab.y - 25 * this.scaleFactor,
				// 		"notificationBell",
				// 	)
				// 	.setOrigin(0.5)
				// 	.setScale(this.scaleFactor / 2)
				// 	.setDepth(10)

				playNotificationAnimation(this,
					{
						xPos: this.activityTab.x + 50 * this.scaleFactor,
						yPos: this.activityTab.y - 25 * this.scaleFactor
					}
				)
			}
		}

		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel < 6) {
				this.activityTab.input.enabled = false
				this.activityTab.alpha = 0.5
			}
			if (this.savedMiniLevel === 6) {
				// this.activityNotificationBell = this.add
				// 	.image(
				// 		this.activityTab.x + 50 * this.scaleFactor,
				// 		this.activityTab.y - 25 * this.scaleFactor,
				// 		"notificationBell",
				// 	)
				// 	.setOrigin(0.5)
				// 	.setScale(this.scaleFactor / 2)
				// 	.setDepth(10)

				playNotificationAnimation(this,
					{
						xPos: this.activityTab.x + 50 * this.scaleFactor,
						yPos: this.activityTab.y - 25 * this.scaleFactor
					}
				)
			}

			if (this.savedMiniLevel >= 10 && this.savedMiniLevel < 15) {
				this.activityTab.input.enabled = false
				this.activityTab.alpha = 0.5
			}

			if (this.savedMiniLevel === 15) {
				// this.activityNotificationBell = this.add
				// 	.image(
				// 		this.activityTab.x + 50 * this.scaleFactor,
				// 		this.activityTab.y - 25 * this.scaleFactor,
				// 		"notificationBell",
				// 	)
				// 	.setOrigin(0.5)
				// 	.setScale(this.scaleFactor / 2)
				// 	.setDepth(10)

				playNotificationAnimation(this,
					{
						xPos: this.activityTab.x + 50 * this.scaleFactor,
						yPos: this.activityTab.y - 25 * this.scaleFactor
					}
				)
			}
			if (this.savedMiniLevel >= 18 && this.savedMiniLevel < 21) {
				this.activityTab.input.enabled = false
				this.activityTab.alpha = 0.5
			}

			if (this.savedMiniLevel === 21) {
				// this.activityNotificationBell = this.add
				// 	.image(
				// 		this.activityTab.x + 50 * this.scaleFactor,
				// 		this.activityTab.y - 25 * this.scaleFactor,
				// 		"notificationBell",
				// 	)
				// 	.setOrigin(0.5)
				// 	.setScale(this.scaleFactor / 2)
				// 	.setDepth(10)

				playNotificationAnimation(this,
					{
						xPos: this.activityTab.x + 50 * this.scaleFactor,
						yPos: this.activityTab.y - 25 * this.scaleFactor
					}
				)
			}
		}

		// Add event listeners to tabs
		this.setupTabListeners()

		// Add close button for detail view
		this.createDetailCloseButton()
	}

	setupTabListeners() {
		this.activityTab.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			destroyIndicator(this)
			if (this.notificationBell) {
				this.notificationBell.destroy()
			}
			if (this.tutorialHand) {
				this.tutorialHand.destroy()
			}
			if (this.savedMiniLevel >= 3) {
				console.log("Set Activity Tab Active")
				this.activityTabActive = false
			}
			if (this.activityTabActive) return
			if (this.currentPlanet === 1) {
			}
			if (this.currentPlanet === 2) {
			}
			if (this.currentPlanet === 3) {
				if (this.savedMiniLevel === 3) {
					return
				}
			}

			this.activityTabActive = true
			this.detailsTabActive = false

			if (this.activityNotificationBell) {
				this.activityNotificationBell.destroy()
			}

			this.detailsTab.setTexture("detailsInactive")
			this.activityTab.setTexture("activityActive")
			this.createActivityLog()
		})

		this.detailsTab.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			if (this.detailsTabActive) return

			this.entryCount = 1

			this.detailsTabActive = true
			this.activityTabActive = false
			this.activityBackGround.destroy()
			this.saveActivityButton.destroy()
			this.fedPill.destroy()
			this.fedPillText.destroy()
			this.dropdownElement.remove()
			this.numberInputElement.remove()
			if (this.requiredTextElement) {
				this.requiredTextElement.remove()
			}

			if (this.dropdownElement2) this.dropdownElement2.remove()
			if (this.numberInputElement2) this.numberInputElement2.remove()
			if (this.requiredTextElement2) this.requiredTextElement2.remove()

			this.detailsTab.setTexture("detailsActive")
			this.activityTab.setTexture("activityInactive")
			this.createDetailScroll(this.selectedCreatureIndex, this.dischargedState)
		})
	}

	createDetailCloseButton() {
		this.galleryCloseButton = this.add.image(
			this.appBar.x + 230 * this.scaleFactor,
			this.appBar.y,
			"appCloseButton",
		).setScale(this.scaleFactor * 0.5)

		this.galleryCloseButton.setInteractive().on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			// this.closeDetailView()
			// destroyTooltip(this)

			destroyTooltip(this)
			this.cleanupScene()

			this.entryCount = 1

			this.scene.stop("CreatureDatabase")
			this.scene.resume("TabletScene")
		})
	}

	closeDetailView() {
		// Remove scroll panel
		this.removeScrollPanel()

		// if (this.planetNamePill) {
		// 	this.planetNamePill.setVisible(false)
		// }

		// if (this.planetNameText) {
		// 	this.planetNameText.setVisible(false)
		// }

		// Reset UI state
		this.galleryViewGroup.setVisible(true)
		this.detailViewOpen = false

		// Destroy tab components
		if (this.activityTab) this.activityTab.destroy()
		if (this.detailsTab) this.detailsTab.destroy()
		if (this.tabHolder) this.tabHolder.destroy()
		if (this.galleryCloseButton) this.galleryCloseButton.destroy()

		if (this.activityBackGround) this.activityBackGround.destroy()
		if (this.saveActivityButton) this.saveActivityButton.destroy()
		if (this.fedPill) this.fedPill.destroy()
		if (this.fedPillText) this.fedPillText.destroy()
		if (this.dropdownElement) this.dropdownElement.remove()
		if (this.numberInputElement) this.numberInputElement.remove()
		if (this.requiredTextElement) this.requiredTextElement.remove()
		if (this.dropdownElement2) this.dropdownElement2.remove()
		if (this.numberInputElement2) this.numberInputElement2.remove()
		if (this.requiredTextElement2) this.requiredTextElement2.remove()

		this.detailViewOpen = false
		this.detailsTabActive = true
		this.activityTabActive = false
		this.selectedCreatureIndex = null
	}

	removeScrollPanel() {
		if (this.scrollListener) {
			this.scrollListener.element.removeEventListener('scroll', this.scrollListener.handler)
			this.scrollListener = null
		}

		this.destroyCustomScrollbar()

		const oldPanel = document.getElementById("scroll-panel")
		if (oldPanel) oldPanel.remove()
	}

	createActivityLog() {
		this.removeScrollPanel()

		this.activityBackGround = this.add
			.image(
				this.tabHolder.x,
				this.tabHolder.y + 35 * this.scaleFactor,
				"tabletBG",
			)
			.setScale(this.scaleFactor * 0.93, this.scaleFactor * 0.64)
			.setOrigin(0.5, 0)

		this.fedPill = this.add
			.image(
				this.activityBackGround.x / 2 + 30 * this.scaleFactor,
				this.activityBackGround.y + 30 * this.scaleFactor,
				"activityPill",
			)
			.setScale(this.scaleFactor)

		this.fedPillText = this.add
			.text(this.fedPill.x, this.fedPill.y, "Fed", {
				fontFamily: "Space Grotesk, sans-serif",
				fontSize: this.fontSize - 8 * this.scaleFactor,
				color: "white",
				align: "center",
				resolution: 2,
			})
			.setOrigin(0.5)

		this.addEntry = this.add
			.image(this.fedPill.x, this.fedPill.y + 65 * this.scaleFactor, "addEntry")
			.setScale(this.scaleFactor * 0.8)
			.setInteractive()

		this.addEntryText = this.add
			.text(
				this.addEntry.x + 150 * this.scaleFactor,
				this.addEntry.y,
				"Add another feeding entry",
				{
					fontFamily: "Space Grotesk, sans-serif",
					fontSize: this.fontSize - 8 * this.scaleFactor,
					color: "#11044E",
					align: "center",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
			.setInteractive()

		if (this.currentPlanet === 1 && this.savedMiniLevel === 9) {
			displayTutorialHand(this, {
				xPos: this.fedPill.x + 200 * this.scaleFactor,
				yPos: this.fedPill.y + 80 * this.scaleFactor,
				rotation: 30,
			})
		}

		if (this.currentPlanet === 2 && this.savedMiniLevel === 3) {
			displayTutorialHand(this, {
				xPos: this.fedPill.x + 240 * this.scaleFactor,
				yPos: this.fedPill.y + 70 * this.scaleFactor,
				rotation: -30,
			})
		}

		if (this.currentPlanet === 2 && this.savedMiniLevel === 9) {
			displayTutorialHand(this, {
				xPos: this.fedPill.x + 240 * this.scaleFactor,
				yPos: this.fedPill.y + 70 * this.scaleFactor,
				rotation: -30,
			})
		}

		if (this.currentPlanet <= 2) {
			this.addEntryText.input.enabled = false
			this.addEntry.input.enabled = false
			this.addEntryText.setAlpha(0.5)
			this.addEntry.setAlpha(0.5)
		}

		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel === 6) {
				// displayTooltip(
				// 	this,
				// 	this.addEntryText.x,
				// 	this.addEntryText.y + 75 * this.scaleFactor,
				// 	"small",
				// 	"Down",
				// 	"You fed your creature more than one type of food. Add another entry by pressing the plus icon here",
				// 	15,
				// )
				displayTooltip(this, {
					xPos: this.addEntry.x,
					yPos: this.addEntry.y + 65 * this.scaleFactor,
					type: "addFoodTip",
					scale: 1,
					text: "[b]Add another food\nitem[/b] by pressing the\n[b]plus icon[/b] here",
					fontScale: -8,
					xTextOffset: 1,
					yTextOffset: 6,
					wrapWidth: 1,
				})
			}

			if (this.savedMiniLevel === 15) {
				this.addEntryText.input.enabled = false
				this.addEntry.input.enabled = false
				this.addEntryText.setAlpha(0.5)
				this.addEntry.setAlpha(0.5)
			}
		}

		this.addEntry.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.addNewEntry()
		})

		this.addEntryText.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.addNewEntry()
		})
		// Create the dropdown element manually and add it to the document
		const gameContainer = document.getElementById("game")
		const rect = gameContainer.getBoundingClientRect()

		// Remove any existing dropdown and input from previous calls
		const existingDropdown = document.getElementById("activity-dropdown")
		if (existingDropdown) {
			existingDropdown.remove()
		}

		const existingInput = document.getElementById("activity-number-input")
		if (existingInput) {
			existingInput.remove()
		}

		const isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent,
			)

		let yOffset = 0
		if (isMobile) {
			yOffset = 5
		} else {
			yOffset = 8
		}

		// Create select element
		const select = document.createElement("select")
		select.id = "activity-dropdown"
		select.style.transformOrigin = "0 0"

		// Apply styles with very high z-index
		select.style.position = "absolute"
		select.style.left = `${this.fedPill.x + 65 * this.scaleFactor}px`
		select.style.top = `${this.activityBackGround.y + yOffset * this.scaleFactor}px`
		select.style.width = `${150 * this.scaleFactor}px`
		select.style.height = `${40 * this.scaleFactor}px`
		select.style.fontSize = `${(12) * this.scaleFactor}px`
		select.style.fontFamily = "Space Grotesk, sans-serif"
		select.style.padding = "5px"
		select.style.borderRadius = "12px"
		select.style.border = "1px solid #3E27BE"
		select.style.background = "#ffffff"
		select.style.color = "#11044E"
		select.style.zIndex = "1000" // Very high z-index to ensure visibility

		// Add custom arrow styling
		select.style.webkitAppearance = "none"
		select.style.mozAppearance = "none"
		select.style.appearance = "none"
		select.style.backgroundImage = "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e\")"
		select.style.backgroundRepeat = "no-repeat"
		select.style.backgroundPosition = "right 12px center"
		select.style.backgroundSize = "24px 24px"

		// Add hover effect
		select.addEventListener('mouseenter', () => {
			select.style.backgroundImage = "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%233E27BE' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e\")"
		})

		select.addEventListener('mouseleave', () => {
			select.style.backgroundImage = "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e\")"
		})


		// Add default "Select" option
		const defaultOption = document.createElement("option")
		defaultOption.value = "select" // Give it a specific value instead of empty
		defaultOption.textContent = "Select"
		defaultOption.disabled = true
		defaultOption.hidden = true
		defaultOption.selected = true
		select.appendChild(defaultOption)

		// Create options
		const options = [
			"Emberfruit",
			"Elder Moss",
			"Chameleon Slugs",
			"Luminishell Crustaceans",
			"Dreamblossom Petals",
			"Nebula Noodles",
			"Beetlefish",
			"Phantom Fungus",
			"Arachsquid",
			"Molten Marrow",
			"Shadow Beans",
			"Starfruit Saplings",
			"Spikumber",
		]

		options.forEach((optionText) => {
			const option = document.createElement("option")
			option.value = optionText.toLowerCase()
			option.text = optionText
			select.appendChild(option)
		})

		// Add the select element directly to the document body
		// Add to the HTML UI container instead of body
		const htmlContainer = document.getElementById("html-ui-container")
		htmlContainer.appendChild(select)
		//document.body.appendChild(select)

		select.addEventListener("change", (event) => {
			destroyTooltip(this)

			if (this.tutorialHand) {
				this.tutorialHand.destroy()
			}
		})

		// Create number input element
		const numberInput = document.createElement("input")
		numberInput.id = "activity-number-input"
		numberInput.type = "number"
		numberInput.inputMode = "numeric"
		numberInput.pattern = "[0-9]*"
		numberInput.min = "0"
		numberInput.max = "100"
		//numberInput.value = "1" // Default value

		// Apply styles for number input
		numberInput.style.position = "absolute"
		numberInput.style.left = `${this.fedPill.x + 225 * this.scaleFactor}px`
		numberInput.style.top = `${this.activityBackGround.y + (yOffset + 3) * this.scaleFactor}px`
		numberInput.style.width = `${80 * this.scaleFactor}px`
		numberInput.style.height = `${40 * this.scaleFactor}px`
		numberInput.style.fontSize = `${18 * this.scaleFactor}px`
		numberInput.style.fontFamily = "Space Grotesk, sans-serif"
		numberInput.style.padding = "5px"
		numberInput.style.borderRadius = "12px"
		numberInput.style.border = "1px solid #3E27BE"
		numberInput.style.background = "#ffffff"
		numberInput.style.color = "#11044E"
		numberInput.style.zIndex = "1000"
		numberInput.style.textAlign = "center"

		numberInput.addEventListener("input", (event) => {
			const inputValue = event.target.value
			console.log(`Number entered: ${inputValue}`)
			if (inputValue) {
				if (this.currentPlanet === 1) {
					if (this.savedMiniLevel === 3) {
						displayIndicator(
							this,
							this.saveActivityButton.x,
							this.saveActivityButton.y - 5 * this.scaleFactor,
							1,
							"foodSaveIndicator",
						)

						if (this.fedPillOverlayRef) {
							this.fedPillOverlayRef.remove()
							if (!this.saveOverlayRef) {
								const overlay = phaserOverlay(this);

								const button = this.saveActivityButton

								overlay.setTargetByCoords(
									this.saveActivityButton.x - button.width * this.scaleFactor * 0.5,
									this.saveActivityButton.y - button.height * this.scaleFactor * 0.5 - 5 * this.scaleFactor,
									button.width * this.scaleFactor,
									button.height * this.scaleFactor,
									15
								)

								this.saveOverlayRef = overlay

								destroyTooltip(this)

								displayTutorialHand(this, {
									xPos: this.saveActivityButton.x - button.width * this.scaleFactor * 0.5,
									yPos: this.saveActivityButton.y - button.height * this.scaleFactor * 0.5 - 45 * this.scaleFactor,
									rotation: 140
								})

								overlay.setAboveOverlay([this.tutorialHand])
							}
						}
					}

					if (this.savedMiniLevel === 9) {
						const button = this.saveActivityButton

						displayTutorialHand(this, {
							xPos: this.saveActivityButton.x - button.width * this.scaleFactor * 0.5,
							yPos: this.saveActivityButton.y - button.height * this.scaleFactor * 0.5 - 45 * this.scaleFactor,
							rotation: 140
						})
					}

					this.saveActivityButton.input.enabled = true
					this.saveActivityButton.setAlpha(1)
					this.saveActivityText.setAlpha(1)
				}
				if (this.currentPlanet === 2) {
					if (this.savedMiniLevel === 3) {
						displayIndicator(
							this,
							this.saveActivityButton.x,
							this.saveActivityButton.y - 5 * this.scaleFactor,
							1,
							"foodSaveIndicator",
						)

						const button = this.saveActivityButton

						displayTutorialHand(this, {
							xPos: this.saveActivityButton.x - button.width * this.scaleFactor * 0.5,
							yPos: this.saveActivityButton.y - button.height * this.scaleFactor * 0.5 - 45 * this.scaleFactor,
							rotation: 140
						})
					}

					this.saveActivityButton.input.enabled = true
					this.saveActivityButton.setAlpha(1)
					this.saveActivityText.setAlpha(1)
				}

				if (this.currentPlanet === 3) {
					if (this.savedMiniLevel === 15) {
						this.saveActivityButton.input.enabled = true
						this.saveActivityButton.setAlpha(1)
						this.saveActivityText.setAlpha(1)
					}
				}

			} else {
				this.saveActivityButton.input.enabled = false
				this.saveActivityButton.setAlpha(0.5)
				this.saveActivityText.setAlpha(0.5)
				destroyIndicator(this)
			}
		})

		// Create required field text
		const requiredText = document.createElement("div")
		requiredText.id = "activity-required-text"
		requiredText.textContent = "*required field"

		// Apply styles for required text
		requiredText.style.position = "absolute"
		requiredText.style.left = `${this.fedPill.x + 225 * this.scaleFactor}px`
		requiredText.style.top = `${this.activityBackGround.y + (yOffset + 50) * this.scaleFactor}px`
		requiredText.style.fontSize = `${9 * this.scaleFactor}px`
		requiredText.style.fontFamily = "Space Grotesk, sans-serif"
		requiredText.style.color = "#11044E" // Light gray color
		requiredText.style.zIndex = "1000"

		// Add the number input element directly to the document body
		// document.body.appendChild(numberInput)
		// document.body.appendChild(requiredText)
		htmlContainer.appendChild(numberInput)
		htmlContainer.appendChild(requiredText)

		// select.value = null
		// select.disabled = false

		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 3) {
				select.value = "emberfruit"
				select.disabled = true
				select.style.opacity = "0.7"
				select.style.cursor = "not-allowed"
				select.style.backgroundColor = "#f0f0f0" // Light grey background
				select.style.borderColor = "#ccc"
				select.style.backgroundImage = "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666666' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e\")"

				displayTooltip(this, {
					xPos: this.fedPill.x + 255 * this.scaleFactor,
					yPos: this.fedPill.y + 65 * this.scaleFactor,
					type: "addFoodTip",
					scale: 1,
					text: "Enter the [b]number\nof foods[/b] given",
					fontScale: -7,
					xTextOffset: 1,
					yTextOffset: 3,
					wrapWidth: 0.9,
				})

				//remove overlay
				if (this.activityOverlayRef) {
					this.activityOverlayRef.remove()
				}

				const overlay = phaserOverlay(this);

				const button = this.fedPill

				overlay.setTargetByCoords(
					this.fedPill.x + 440 * this.scaleFactor * 0.5,
					this.fedPill.y - 60 * this.scaleFactor * 0.5,
					button.width * this.scaleFactor + 14 * this.scaleFactor,
					button.height * this.scaleFactor + 14 * this.scaleFactor,
					15
				)

				overlay.setAboveOverlay([this.tooltip, this.tooltipText])

				this.fedPillOverlayRef = overlay
				// displayIndi
			}

			if (this.savedMiniLevel === 9) {
				select.value = "elder moss"
				select.disabled = true
				select.style.opacity = "0.7"
				select.style.cursor = "not-allowed"
				select.style.backgroundColor = "#f0f0f0" // Light grey background
				select.style.borderColor = "#ccc"
				select.style.backgroundImage = "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666666' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e\")"
			}
		}
		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel === 3) {
				// select.value = null
				// select.disabled = false

				// displayTooltip(
				// 	this,
				// 	this.fedPill.x + 155 * this.scaleFactor,
				// 	this.fedPill.y + 65 * this.scaleFactor,
				// 	"small",
				// 	"Down",
				// 	"Choose the food you fed to your creature from the list of options",
				// 	15,
				// )

				displayTooltip(this, {
					xPos: this.fedPill.x + 130 * this.scaleFactor,
					yPos: this.fedPill.y + 65 * this.scaleFactor,
					type: "pickFoodTip",
					scale: 1,
					text: "[b]Press this[/b] to pick\nthe food that you\nfed your creature",
					fontScale: -7,
					xTextOffset: 1,
					yTextOffset: 4,
					wrapWidth: 0.9,
				})
			}
		}

		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel === 7) {
				// select.value = null
				// select.disabled = false

				displayTooltip(
					this,
					this.fedPill.x + 155 * this.scaleFactor,
					this.fedPill.y + 65 * this.scaleFactor,
					"small",
					"Down",
					"Choose the food you fed to your creature from the list of options",
					15,
				)


			}
		}

		document.addEventListener("touchstart", (event) => {
			if (!numberInput.contains(event.target)) {
				numberInput.blur()
			}
		})

		// Store references to clean up later
		this.dropdownElement = select
		this.numberInputElement = numberInput
		this.requiredTextElement = requiredText

		let date = new Date()
		let day = date.getDate()
		let month = date.getMonth() + 1
		let year = date.getFullYear()
		let systemDate = `${day}/${month}/${year}`

		this.pillDate = this.add.text(
			this.fedPill.x + 350 * this.scaleFactor,
			this.fedPill.y,
			systemDate,
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 8 * this.scaleFactor,
				color: "#11044E",
				align: "center",
				resolution: 2,
				fontWeight: "400",
			},
		)

		// Add a cleanup method to the scene
		const originalSceneStop = this.scene.stop
		this.scene.stop = (key) => {
			// Remove elements when scene stops
			if (this.dropdownElement) {
				this.dropdownElement.remove()
			}
			if (this.numberInputElement) {
				this.numberInputElement.remove()
			}
			if (this.requiredTextElement) {
				this.requiredTextElement.remove()
			}
			if (this.dropdownElement2) this.dropdownElement2.remove()
			if (this.numberInputElement2) this.numberInputElement2.remove()
			if (this.requiredTextElement2) this.requiredTextElement2.remove()
			originalSceneStop.call(this.scene, key)
		}

		this.saveActivityButton = this.add
			.image(
				this.activityBackGround.x + 170 * this.scaleFactor,
				this.activityBackGround.y + 170 * this.scaleFactor,
				"saveBtn",
			)
			.setScale(this.scaleFactor)
			.setInteractive()

		this.saveActivityText = this.add
			.text(
				this.saveActivityButton.x - 25 * this.scaleFactor,
				this.saveActivityButton.y - 15 * this.scaleFactor,
				"SAVE",
				{
					fontFamily: "Gluten",
					fontSize: this.fontSize + 20 * this.scaleFactor,
					color: "white",
					align: "center",
					resolution: 2,
					fontWeight: "700",
					fontStyle: "bold",
				},
			)
			.setScale(0.5)
		this.saveActivityButton.input.enabled = false
		this.saveActivityButton.setAlpha(0.5)
		this.saveActivityText.setAlpha(0.5)

		// if (this.currentPlanet === 2) {
		// 	if (this.savedMiniLevel === 3) {
		// 		displayIndicator(
		// 			this,
		// 			this.saveActivityButton.x,
		// 			this.saveActivityButton.y - 5 * this.scaleFactor,
		// 			1,
		// 			"foodSaveIndicator",
		// 		)
		// 	}
		// }

		this.saveActivityButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.saveActivity()
		})
	}
	addNewEntry() {
		destroyTooltip(this)
		// Keep track of feeding entries
		if (!this.feedingEntries) {
			this.feedingEntries = [] // Initialize array to track entries
			this.entryCount = 1 // Start with 1 because we already have the first entry
		}
		if (this.entryCount === 2) {
			console.log("Maximum number of entries reached.")
			return
		}

		if (this.currentPlanet === 3 && this.savedMiniLevel === 15) {
			console.log("Unpressable here")
			return
		}

		// Calculate the position for the new feeding pill
		const yOffset = 65 * this.scaleFactor // Vertical spacing between entries
		const entryYPosition = this.addEntry.y // Use current addEntry position

		// Create a new feeding pill at the current addEntry position
		const newFedPill = this.add
			.image(this.fedPill.x, entryYPosition, "activityPill")
			.setScale(this.scaleFactor)

		// Add text for the new feeding pill
		const newFedPillText = this.add
			.text(newFedPill.x, newFedPill.y, "Fed", {
				fontFamily: "Space Grotesk, sans-serif",
				fontSize: this.fontSize - 8 * this.scaleFactor,
				color: "white",
				align: "center",
				resolution: 2,
			})
			.setOrigin(0.5)

		// Create dropdown and number input for the new entry
		const gameContainer = document.getElementById("game")

		// Create select element for new entry
		const newSelect = document.createElement("select")
		const selectId = "activity-dropdown-" + this.entryCount
		newSelect.id = selectId

		// Apply styles
		newSelect.style.position = "absolute"
		newSelect.style.left = `${newFedPill.x + 65 * this.scaleFactor}px`
		newSelect.style.top = `${newFedPill.y - 23 * this.scaleFactor}px`
		newSelect.style.width = `${150 * this.scaleFactor}px`
		newSelect.style.height = `${40 * this.scaleFactor}px`
		newSelect.style.fontSize = `${(12) * this.scaleFactor}px`
		newSelect.style.fontFamily = "Space Grotesk, sans-serif"
		newSelect.style.padding = "5px"
		newSelect.style.borderRadius = "12px"
		newSelect.style.border = "1px solid #3E27BE"
		newSelect.style.background = "#ffffff"
		newSelect.style.color = "#11044E"
		newSelect.style.zIndex = "1000"

		// Add custom arrow styling
		newSelect.style.webkitAppearance = "none"
		newSelect.style.mozAppearance = "none"
		newSelect.style.appearance = "none"
		newSelect.style.backgroundImage = "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e\")"
		newSelect.style.backgroundRepeat = "no-repeat"
		newSelect.style.backgroundPosition = "right 12px center"
		newSelect.style.backgroundSize = "24px 24px"

		// Add hover effect
		newSelect.addEventListener('mouseenter', () => {
			newSelect.style.backgroundImage = "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%233E27BE' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e\")"
		})

		newSelect.addEventListener('mouseleave', () => {
			newSelect.style.backgroundImage = "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e\")"
		})

		// Add default "Select" option
		const defaultOption = document.createElement("option")
		defaultOption.value = "select" // Give it a specific value instead of empty
		defaultOption.textContent = "Select"
		defaultOption.disabled = true
		defaultOption.hidden = true
		defaultOption.selected = true
		newSelect.appendChild(defaultOption)

		// Create options
		const options = [
			"Emberfruit",
			"Elder Moss",
			"Chameleon Slugs",
			"Luminishell Crustaceans",
			"Dreamblossom Petals",
			"Nebula Noodles",
			"Beetlefish",
			"Phantom Fungus",
			"Arachsquid",
			"Molten Marrow",
			"Shadow Beans",
			"Starfruit Saplings",
			"Spikumber",
		]

		options.forEach((optionText) => {
			const option = document.createElement("option")
			option.value = optionText.toLowerCase()
			option.text = optionText
			newSelect.appendChild(option)
		})

		// Add the select element to the document body
		const htmlContainer = document.getElementById("html-ui-container")
		htmlContainer.appendChild(newSelect)
		//document.body.appendChild(newSelect)

		// Create number input element for new entry
		const newNumberInput = document.createElement("input")
		const inputId = "activity-number-input-" + this.entryCount
		newNumberInput.id = inputId
		newNumberInput.type = "number"
		newNumberInput.inputMode = "numeric"
		newNumberInput.pattern = "[0-9]*"
		newNumberInput.min = "0"
		newNumberInput.max = "100"
		//newNumberInput.value = ""

		// Apply styles for number input
		newNumberInput.style.position = "absolute"
		newNumberInput.style.left = `${newFedPill.x + 225 * this.scaleFactor}px`
		newNumberInput.style.top = `${newFedPill.y - 18 * this.scaleFactor}px`
		newNumberInput.style.width = `${80 * this.scaleFactor}px`
		newNumberInput.style.height = `${40 * this.scaleFactor}px`
		newNumberInput.style.fontSize = `${18 * this.scaleFactor}px`
		newNumberInput.style.fontFamily = "Space Grotesk, sans-serif"
		newNumberInput.style.padding = "5px"
		newNumberInput.style.borderRadius = "12px"
		newNumberInput.style.border = "1px solid #3E27BE"
		newNumberInput.style.background = "#ffffff"
		newNumberInput.style.color = "#11044E"
		newNumberInput.style.zIndex = "1000"
		newNumberInput.style.textAlign = "center"

		newNumberInput.addEventListener("input", (event) => {
			const inputValue = event.target.value
			console.log(`Number entered: ${inputValue}`)
			if (this.currentPlanet === 3) {
				if (this.savedMiniLevel === 15) {
					return
				}
				if (inputValue) {
					this.saveActivityButton.input.enabled = true
					this.saveActivityButton.setAlpha(1)
					this.saveActivityText.setAlpha(1)
				} else {
					this.saveActivityButton.input.enabled = false
					this.saveActivityButton.setAlpha(0.5)
					this.saveActivityText.setAlpha(0.5)
					destroyIndicator(this)
				}
			}
		})

		// Create required field text
		const requiredText = document.createElement("div")
		requiredText.id = "activity-required-text"
		requiredText.textContent = "*required field"

		// Apply styles for required text
		requiredText.style.position = "absolute"
		requiredText.style.left = `${this.fedPill.x + 225 * this.scaleFactor}px`
		requiredText.style.top = `${newFedPill.y + 25 * this.scaleFactor}px`
		requiredText.style.fontSize = `${9 * this.scaleFactor}px`
		requiredText.style.fontFamily = "Space Grotesk, sans-serif"
		requiredText.style.color = "#11044E" // Light gray color
		requiredText.style.zIndex = "1000"


		// Add the number input element to the document body
		// document.body.appendChild(newNumberInput)
		// document.body.appendChild(requiredText)
		htmlContainer.appendChild(newNumberInput)
		htmlContainer.appendChild(requiredText)

		let date = new Date()
		let day = date.getDate()
		let month = date.getMonth() + 1
		let year = date.getFullYear()
		let systemDate = `${day}/${month}/${year}`

		this.pillDate02 = this.add.text(
			newFedPill.x + 350 * this.scaleFactor,
			newFedPill.y,
			systemDate,
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 8 * this.scaleFactor,
				color: "#11044E",
				align: "center",
				resolution: 2,
				fontWeight: "400",
			},
		)

		// Store entry information for later reference
		this.feedingEntries.push({
			pill: newFedPill,
			pillText: newFedPillText,
			dropdown: newSelect,
			numberInput: newNumberInput,
			requiredText: requiredText,
		})

		// Move the addEntry button down
		this.addEntry.y += yOffset
		this.addEntryText.y += yOffset

		this.addEntryText.setAlpha(0.5)
		this.addEntry.setAlpha(0.5)

		// Apply conditional logic based on current planet/level
		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 3) {
				newSelect.value = "emberfruit"
				newSelect.disabled = true
				newSelect.style.opacity = "0.7"
				newSelect.style.cursor = "not-allowed"
				newSelect.style.backgroundColor = "#f0f0f0"
				newSelect.style.borderColor = "#ccc"
			}
		}

		// Add event listeners to handle touch input
		document.addEventListener("touchstart", (event) => {
			if (!newNumberInput.contains(event.target)) {
				newNumberInput.blur()
			}
		})
		this.dropdownElement2 = newSelect
		this.numberInputElement2 = newNumberInput
		this.requiredTextElement2 = requiredText
		// Update the scene's cleanup to include these new elements
		const originalSceneStop = this.scene.stop
		this.scene.stop = (key) => {
			// Remove all dropdown and number input elements
			if (this.feedingEntries) {
				this.feedingEntries.forEach((entry) => {
					if (entry.dropdown) entry.dropdown.remove()
					if (entry.numberInput) entry.numberInput.remove()
				})
				this.pillDate02.destroy()
			}

			// Also remove the original elements
			if (this.dropdownElement2) {
				this.dropdownElement2.remove()
			}
			if (this.numberInputElement2) {
				this.numberInputElement2.remove()
			}
			if (this.requiredTextElement2) {
				this.requiredTextElement2.remove()
			}

			originalSceneStop.call(this.scene, key)
		}

		// Increment entry count for next addition
		this.entryCount++

		// Check if we need to adjust the background or save button position
		if (this.entryCount > 3) {
			// Extend the background if we have many entries
			this.activityBackGround.scaleY += 0.1 * this.scaleFactor

			// Move the save button down if needed
			this.saveActivityButton.y = this.addEntry.y + 50 * this.scaleFactor
			this.saveActivityText.y =
				this.saveActivityButton.y - 15 * this.scaleFactor
		}
	}

	createDetailScroll(creatureIndex, isDischarged) {
		this.removeScrollPanel()

		this.planetNamePill.setVisible(false)
		this.planetNameText.setVisible(false)

		this.backButton.setVisible(true)

		if (this.pillDate02) {
			this.pillDate02.destroy()
		}

		if (this.currentPlanet > 0 && this.currentPlanet < 3) {
			if (this.savedMiniLevel === 6) {
				console.log("Update to level 7")
				this.loadCreatureData()
				updateMiniLevel(this.savedMiniLevel)
			}
		}

		// Create and style the scroll panel
		const scrollPanel = document.createElement("div")
		scrollPanel.id = "scroll-panel"
		scrollPanel.style.transformOrigin = "50% 0"

		scrollPanel.setAttribute("lang", "en-GB")
		// Apply styles
		this.applyScrollPanelStyles(scrollPanel)

		// Add creature info to panel
		this.addCreatureInfo(scrollPanel, creatureIndex)

		// Add form elements
		const form = this.createForm(creatureIndex, isDischarged)
		scrollPanel.appendChild(form)

		this.syncHTMLContainer()

		// Add to game
		this.addScrollPanelToGame(scrollPanel)

		// Store reference to scroll panel and create custom scrollbar
		this.domScrollPanel = scrollPanel;
		this.createCustomScrollbar();

		if (this.currentPlanet == 1 && this.savedMiniLevel == 1) {
			this.setupScrollListener(scrollPanel)
		}

		if (this.currentPlanet == 2 && this.savedMiniLevel == 1) {
			//setup listener to see when color drop down is visible 
			this.setupColorDropdownListener(scrollPanel)
		}
	}

	createCustomScrollbar() {
		const scrollPanel = this.domScrollPanel;
		if (!scrollPanel) return;

		let container = document.getElementById('tutorial-scrollbar-container');
		if (!container) {
			container = document.createElement('div');
			container.id = 'tutorial-scrollbar-container';
			document.body.appendChild(container);
		}

		const syncScrollbarPosition = () => {
			const canvas = this.game.canvas;
			const gameContainer = document.getElementById('game');
			if (!canvas || !gameContainer) return;

			const canvasRect = canvas.getBoundingClientRect();
			const containerRect = gameContainer.getBoundingClientRect();

			const scaleX = canvasRect.width / this.game.config.width;
			const scaleY = canvasRect.height / this.game.config.height;
			const scale = Math.min(scaleX, scaleY);

			const offsetX = (containerRect.width - (this.game.config.width * scale)) / 2;
			const offsetY = (containerRect.height - (this.game.config.height * scale)) / 2;

			container.style.position = 'fixed';
			container.style.left = `${containerRect.left}px`;
			container.style.top = `${containerRect.top}px`;
			container.style.width = `${this.game.config.width}px`;
			container.style.height = `${this.game.config.height}px`;
			container.style.transform = `scale(${scale}) translate(${offsetX / scale}px, ${offsetY / scale}px)`;
			container.style.transformOrigin = 'top left';

			this.currentScrollbarScale = scale;
		};

		const styleId = 'tutorial-scrollbar-styles';
		if (!document.getElementById(styleId)) {
			const thumbSVG = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 180'%3E%3Cdefs%3E%3ClinearGradient id='thumbGrad' x1='0%25' y1='0%25' x2='0%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%23E8E8FF;stop-opacity:1' /%3E%3Cstop offset='50%25' style='stop-color:%23BECCFF;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%23A8A8FF;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='80' height='180' rx='40' fill='url(%23thumbGrad)' stroke='%2311044E' stroke-width='3'/%3E%3Cellipse cx='40' cy='35' rx='30' ry='18' fill='%23ffffff' opacity='0.3'/%3E%3Crect x='25' y='70' width='30' height='4' rx='2' fill='%23ffffff' opacity='0.5'/%3E%3Crect x='25' y='80' width='30' height='4' rx='2' fill='%23ffffff' opacity='0.5'/%3E%3Crect x='25' y='90' width='30' height='4' rx='2' fill='%23ffffff' opacity='0.5'/%3E%3C/svg%3E`;

			const style = document.createElement('style');
			style.id = styleId;
			style.innerHTML = `
            #tutorial-scrollbar-container {
                position: fixed;
                top: 0;
                left: 0;
                width: ${this.game.config.width}px;
                height: ${this.game.config.height}px;
                pointer-events: none;
                z-index: 1000;
            }

            .tutorial-scrollbar-wrapper {
                position: absolute;
                left: ${this.tabHolder.x + 245 * this.scaleFactor}px;
                top: ${this.gameH / 2 + 40 * this.scaleFactor}px;
                transform: translate(-50%, -50%) scale(${this.scaleFactor});
                transform-origin: center center;
                pointer-events: auto;
                display: flex;
                gap: 20px;
            }

            .tutorial-scrollbar-track {
                width: 15px;
                height: 250px;
                background: #5C58EB;
                border-radius: 50px;
                border: 3px solid #11044E;
                position: relative;
                overflow: visible;
                pointer-events: auto;
            }

            .tutorial-scrollbar-thumb-hitarea {
                width: 160%;
                height: 80px;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                cursor: grab;
                pointer-events: auto;
                background: transparent;
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                z-index: 10;
            }

            .tutorial-scrollbar-thumb-hitarea.dragging {
                cursor: grabbing;
            }

            .tutorial-scrollbar-thumb-hitarea.locked {
                opacity: 0.4;
                cursor: not-allowed;
            }

            .tutorial-scrollbar-thumb {
                width: 100%;
                height: 60px;
                background-image: url("${thumbSVG}");
                background-size: cover;
                background-position: center;
                border-radius: 50px;
                box-shadow: 0 0 10px rgba(168, 168, 255, 0.5);
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                pointer-events: none;
                transition: box-shadow 0.3s ease;
            }

            .tutorial-scrollbar-thumb.at-bottom {
                box-shadow: 0 0 20px rgba(144, 238, 144, 0.8);
            }
        `;
			document.head.appendChild(style);
		}

		const wrapper = document.createElement('div');
		wrapper.className = 'tutorial-scrollbar-wrapper';
		container.appendChild(wrapper);

		const track = document.createElement('div');
		track.className = 'tutorial-scrollbar-track';
		wrapper.appendChild(track);

		const thumbHitArea = document.createElement('div');
		thumbHitArea.className = 'tutorial-scrollbar-thumb-hitarea';
		track.appendChild(thumbHitArea);

		const thumb = document.createElement('div');
		thumb.className = 'tutorial-scrollbar-thumb';
		thumbHitArea.appendChild(thumb);

		syncScrollbarPosition();
		this.currentScrollbarScale = 1;

		const updateCustomScrollbar = () => {
			const scrollY = scrollPanel.scrollTop;
			const maxScroll = scrollPanel.scrollHeight - scrollPanel.clientHeight;

			if (maxScroll <= 0) {
				thumbHitArea.style.top = '0px';
				return;
			}

			const trackHeight = track.clientHeight;
			const thumbHeight = thumbHitArea.clientHeight;
			const maxThumbTop = trackHeight - thumbHeight;

			const scrollPercentage = scrollY / maxScroll;
			const thumbTop = scrollPercentage * maxThumbTop;

			thumbHitArea.style.top = `${thumbTop}px`;

			if (scrollPercentage >= 0.99) {
				thumb.classList.add('at-bottom');
			} else {
				thumb.classList.remove('at-bottom');
			}

			if (this.scrollLocked) {
				thumbHitArea.classList.add('locked');
			} else {
				thumbHitArea.classList.remove('locked');
			}
		};

		scrollPanel.addEventListener('scroll', updateCustomScrollbar);

		let isDragging = false;
		let startY = 0;
		let startThumbTop = 0;

		const onThumbMouseDown = (e) => {
			if (this.scrollLocked) return;
			isDragging = true;
			startY = e.clientY;
			startThumbTop = parseFloat(thumbHitArea.style.top) || 0;
			thumbHitArea.classList.add('dragging');
			e.preventDefault();
			e.stopPropagation();
		};

		const onMouseMove = (e) => {
			if (!isDragging) return;

			const deltaY = e.clientY - startY;
			const scaledDelta = deltaY / (this.currentScrollbarScale || 1);
			const newThumbTop = startThumbTop + scaledDelta;

			const trackHeight = track.clientHeight;
			const thumbHeight = thumbHitArea.clientHeight;
			const maxThumbTop = trackHeight - thumbHeight;

			const clampedThumbTop = Math.max(0, Math.min(newThumbTop, maxThumbTop));
			thumbHitArea.style.top = `${clampedThumbTop}px`;

			const maxScroll = scrollPanel.scrollHeight - scrollPanel.clientHeight;
			const scrollPercentage = clampedThumbTop / maxThumbTop;
			const newScrollY = scrollPercentage * maxScroll;
			scrollPanel.scrollTop = newScrollY;

			e.preventDefault();
		};

		const onMouseUp = () => {
			if (isDragging) {
				isDragging = false;
				thumbHitArea.classList.remove('dragging');
			}
		};

		const onTouchMove = (e) => {
			if (!isDragging) return;

			const deltaY = e.touches[0].clientY - startY;
			const scaledDelta = deltaY / (this.currentScrollbarScale || 1);
			const newThumbTop = startThumbTop + scaledDelta;

			const trackHeight = track.clientHeight;
			const thumbHeight = thumbHitArea.clientHeight;
			const maxThumbTop = trackHeight - thumbHeight;

			const clampedThumbTop = Math.max(0, Math.min(newThumbTop, maxThumbTop));
			thumbHitArea.style.top = `${clampedThumbTop}px`;

			const maxScroll = scrollPanel.scrollHeight - scrollPanel.clientHeight;
			const scrollPercentage = clampedThumbTop / maxThumbTop;
			const newScrollY = scrollPercentage * maxScroll;
			scrollPanel.scrollTop = newScrollY;

			e.preventDefault();
		};

		thumbHitArea.addEventListener('mousedown', onThumbMouseDown);
		document.addEventListener('mousemove', onMouseMove);
		document.addEventListener('mouseup', onMouseUp);

		// Touch support
		thumbHitArea.addEventListener('touchstart', (e) => {
			if (this.scrollLocked) return;
			isDragging = true;
			startY = e.touches[0].clientY;
			startThumbTop = parseFloat(thumbHitArea.style.top) || 0;
			thumbHitArea.classList.add('dragging');
			e.preventDefault();
		}, { passive: false });

		document.addEventListener('touchmove', onTouchMove, { passive: false });

		document.addEventListener('touchend', () => {
			if (isDragging) {
				isDragging = false;
				thumbHitArea.classList.remove('dragging');
			}
		});

		// Click on track to jump
		const onTrackClick = (e) => {
			if (this.scrollLocked) return;
			if (e.target === thumbHitArea || thumbHitArea.contains(e.target)) return;

			const rect = track.getBoundingClientRect();
			const clickY = e.clientY - rect.top;
			const trackHeight = track.clientHeight;
			const thumbHeight = thumbHitArea.clientHeight;
			const maxThumbTop = trackHeight - thumbHeight;

			const newThumbTop = Math.max(0, Math.min(clickY - thumbHeight / 2, maxThumbTop));
			thumbHitArea.style.top = `${newThumbTop}px`;

			const maxScroll = scrollPanel.scrollHeight - scrollPanel.clientHeight;
			const scrollPercentage = newThumbTop / maxThumbTop;
			const newScrollY = scrollPercentage * maxScroll;
			scrollPanel.scrollTop = newScrollY;
		};

		track.addEventListener('click', onTrackClick);

		const resizeHandler = () => syncScrollbarPosition();
		window.addEventListener('resize', resizeHandler);

		setTimeout(updateCustomScrollbar, 100);

		this.customScrollbar = {
			container,
			thumb,
			thumbHitArea,
			track,
			scrollListener: updateCustomScrollbar,
			resizeHandler,
			cleanup: () => {
				thumbHitArea.removeEventListener('mousedown', onThumbMouseDown);
				document.removeEventListener('mousemove', onMouseMove);
				document.removeEventListener('mouseup', onMouseUp);
				document.removeEventListener('touchmove', onTouchMove);
				track.removeEventListener('click', onTrackClick);
				scrollPanel.removeEventListener('scroll', updateCustomScrollbar);
				window.removeEventListener('resize', resizeHandler);
				container.remove();
			}
		};
	}

	destroyCustomScrollbar() {
		if (this.customScrollbar) {
			this.customScrollbar.cleanup();
			this.customScrollbar = null;
		}
	}

	/**
	 * Shows the tutorial tooltip and hand when checkboxes come into view.
	 */
	applyCheckboxScrollLock(scrollPanel) {
		if (!this.keepCheking) return;
		this.keepCheking = false;

		// Remove the scroll listener — we only need to trigger this once
		if (this.scrollListener) {
			this.scrollListener.element.removeEventListener('scroll', this.scrollListener.handler);
			this.scrollListener = null;
		}

		displayTooltip(this, {
			xPos: this.gameW / 2 + 325 * this.scaleFactor,
			yPos: this.gameH / 2 - 50 * this.scaleFactor,
			type: "mediumChunkyLeftTip",
			scale: 1.2,
			text: "Check the correct\n[b]features[/b]: (Tail, Horns)",
			fontScale: -8,
			xTextOffset: 3,
			yTextOffset: 1,
			wrapWidth: 1.5,
		});

		displayTutorialHand(this, {
			xPos: this.gameW / 2 + 325 * this.scaleFactor,
			yPos: this.gameH / 2 + 55 * this.scaleFactor,
			rotation: -90
		});

		if (this.scrollAnim) {
			this.scrollAnim.setVisible(false);
		}

		if (this.detailsOverlayRef) {
			this.detailsOverlayRef.setAboveOverlay([this.tooltip, this.tooltipText, this.tutorialHand]);
		}
	}

	setupScrollListener(scrollPanel) {
		const targetElement = scrollPanel.querySelector('[name="featureOption"]')?.parentElement
		if (!targetElement) return

		this.scrollPanelRef = scrollPanel

		const checkVisibility = () => {
			const containerRect = scrollPanel.getBoundingClientRect()
			const elementRect = targetElement.getBoundingClientRect()

			const isVisible = (
				elementRect.top < containerRect.bottom &&
				elementRect.bottom > containerRect.top
			)

			if (this.keepCheking && isVisible) {
				console.log("Checkbox group is now visible!")
				this.applyCheckboxScrollLock(scrollPanel)
			} else {
				console.log("Checkbox group is not visible")
			}
		}

		scrollPanel.addEventListener('scroll', checkVisibility)
		checkVisibility()

		this.scrollListener = {
			element: scrollPanel,
			handler: checkVisibility
		}
	}

	setupColorDropdownListener(scrollPanel) {
		// Find the color dropdown by looking for the "Colour:" label's next sibling
		const labels = scrollPanel.querySelectorAll('label')
		let colorDropdown = null

		for (let label of labels) {
			if (label.textContent.includes('Colour:')) {
				colorDropdown = label.nextElementSibling
				break
			}
		}

		if (!colorDropdown) {
			console.log("Color dropdown not found")
			return
		}

		let hasTriggered = false // Flag to ensure debug runs only once

		const checkVisibility = () => {
			if (hasTriggered) return // Skip if already triggered

			const containerRect = scrollPanel.getBoundingClientRect()
			const dropdownRect = colorDropdown.getBoundingClientRect()

			const isVisible = (
				dropdownRect.top >= containerRect.top &&
				dropdownRect.bottom <= containerRect.bottom
			) || (
					dropdownRect.top < containerRect.bottom &&
					dropdownRect.bottom > containerRect.top
				)

			if (isVisible) {
				console.log("🎨 Color dropdown is now visible!")
				hasTriggered = true // Set flag to prevent future triggers
				scrollPanel.removeEventListener('scroll', checkVisibility) // Clean up listener

				let wrapWidth = 0
				if (
					this.sys.game.device.os.desktop ||
					this.sys.game.device.os.laptop
				) {
					wrapWidth = 1.8
				} else {
					wrapWidth = 0.9
				}

				displayTooltip02(this, {
					xPos: this.gameW / 2 + 335 * this.scaleFactor,
					yPos: this.gameH / 2 + 130 * this.scaleFactor,
					type: "pressTheDropDownTip",
					scale: 1,
					text: "Press the [b]dropdown[/b]\nto see a list of\noptions to\nchoose from.",
					fontScale: -8,
					xTextOffset: 3,
					yTextOffset: 1.5,
					wrapWidth: wrapWidth,
				})
			}
		}

		scrollPanel.addEventListener('scroll', checkVisibility)
		checkVisibility() // Check immediately in case it's already visible
	}

	setupSaveButtonScrollListener(scrollPanel) {
		if (!this.saveButtonReference) return

		this.keepCheckingSaveButton = true

		const checkSaveButtonVisibility = () => {
			const containerRect = scrollPanel.getBoundingClientRect()
			const saveButtonRect = this.saveButtonReference.getBoundingClientRect()

			const isVisible = (
				saveButtonRect.top >= containerRect.top &&
				saveButtonRect.bottom <= containerRect.bottom
			) || (
					saveButtonRect.top < containerRect.bottom &&
					saveButtonRect.bottom > containerRect.top
				)

			if (this.keepCheckingSaveButton) {
				if (isVisible) {
					console.log("Save button is now visible!")
					this.keepCheckingSaveButton = false

					scrollPanel.removeEventListener('scroll', checkSaveButtonVisibility)

					// Add any additional logic you want when save button becomes visible

				} else {
					console.log("Save button is not visible")
				}
			}
		}

		if (this.currentPlanet === 1) {
			scrollPanel.addEventListener('scroll', checkSaveButtonVisibility)
		}
		checkSaveButtonVisibility()

		this.saveButtonScrollListener = {
			element: scrollPanel,
			handler: checkSaveButtonVisibility
		}
	}

	applyScrollPanelStyles(panel) {
		const styles = {
			position: "absolute",
			width: `${468 * this.scaleFactor}px`,
			height: `${200 * this.scaleFactor}px`,
			overflowY: "scroll",
			overflowX: "hidden",
			borderRadius: "4px",
			border: "2px solid #11044E",
			padding: "3px",
			background: "#fff",
			color: "#11044E",
			fontFamily: "Space Grotesk, sans-serif",
			fontSize: "12px",
			zIndex: "50",
			WebkitOverflowScrolling: "touch",
			// Force scrollbar to always be visible
			scrollbarWidth: "thick",
			scrollbarColor: "#5C58EB #f1f1f1",
			//zoom: "2.5"
		}

		// Apply all styles
		Object.assign(panel.style, styles)

		// Set locale for DD/MM/YYYY date format
		panel.setAttribute("lang", "en-GB")

		// Add global form styles
		const isDesktop = window.innerWidth > 768

		if (
			this.sys.game.device.os.desktop ||
			this.sys.game.device.os.laptop
		) {
			this.addFormStylesDesktop()
		} else {
			this.addFormStyles()
		}
		this.addIOSViewportFix()
	}

	addIOSViewportFix() {
		if (!document.getElementById("ios-viewport-fix")) {
			const styleElement = document.createElement("style")
			styleElement.id = "ios-viewport-fix"
			styleElement.textContent = `
			html, body {
				height: 100%;
				position: fixed;
				overflow: auto;
				-webkit-overflow-scrolling: touch;
				width: 100%;
			}
		`
			document.head.appendChild(styleElement)
		}
	}

	// 			input[type="date"]::-webkit-calendar-picker-indicator,
	// input[type="time"]::-webkit-calendar-picker-indicator {
	//     display: none;
	//     -webkit-appearance: none;
	// }

	//Before Changing
	addFormStyles() {
		// Only add styles once
		if (!document.getElementById("creature-form-styles")) {
			const styleTag = document.createElement("style")
			styleTag.id = "creature-form-styles"

			styleTag.innerHTML = `
/* Custom scrollbar styles for the scroll panel */
#scroll-panel::-webkit-scrollbar {
    width: 16px;
    -webkit-appearance: none;
}

#scroll-panel::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
    margin: 2px;
}

#scroll-panel::-webkit-scrollbar-thumb {
    background: #5C58EB;
    border-radius: 8px;
    border: 3px solid #f1f1f1;
    min-height: 40px;
}

#scroll-panel::-webkit-scrollbar-thumb:hover {
    background: #3E27BE;
}

/* Force scrollbar to always be visible on all browsers */
#scroll-panel {
    scrollbar-width: thin;
    scrollbar-color: #5C58EB #f1f1f1;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll !important;
}

/* Ensure scrollbar is always visible (not fading) */
#scroll-panel::-webkit-scrollbar {
    display: block !important;
}

#scroll-panel::-webkit-scrollbar-thumb {
    visibility: visible !important;
}

#scroll-panel::-webkit-scrollbar-track {
    visibility: visible !important;
}

/* Firefox - force always visible */
@-moz-document url-prefix() {
    #scroll-panel {
        scrollbar-width: thin !important;
        overflow-y: scroll !important;
    }
}

/* Consistent box-sizing for all form elements */
#scroll-panel * {
    box-sizing: border-box;
}

input[type="date"]::-webkit-calendar-picker-indicator,
input[type="time"]::-webkit-calendar-picker-indicator {
    background-image: none;
    background-color: transparent;
    cursor: pointer;
    width: 20px;
    height: 20px;
}

input[type="radio"], select, input[type="text"], input[type="date"], input[type="time"], button {
    padding: 8px;
    margin: 5px 0;
    border-radius: 5px;
    border: none;
    outline: none;
    font-size: 16px;
    font-family: Space Grotesk;
}

input[type="text"], select, input[type="date"], input[type="time"] {
    width: 30%;
    background: #fff;
    color: #11044E;
    padding: 10px;
    border: 1px solid #11044E;
}

/* Custom dropdown styling with bigger arrow */
select {
    width: 30%;
    background: #fff;
    color: #11044E;
    padding: 10px;
    border: 1px solid #11044E;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 24px 24px;
    padding-right: 40px;
}

select:hover {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%233E27BE' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
}

select:disabled {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23656565' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
}

/* Custom arrows for date and time inputs */
input[type="date"], input[type="time"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-right: 40px;
}

/* Calendar icon for date input */
input[type="date"] {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3e%3cline x1='16' y1='2' x2='16' y2='6'/%3e%3cline x1='8' y1='2' x2='8' y2='6'/%3e%3cline x1='3' y1='10' x2='21' y2='10'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 20px 20px;
}

input[type="date"]:hover {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%233E27BE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3e%3cline x1='16' y1='2' x2='16' y2='6'/%3e%3cline x1='8' y1='2' x2='8' y2='6'/%3e%3cline x1='3' y1='10' x2='21' y2='10'/%3e%3c/svg%3e");
}

/* Clock icon for time input */
input[type="time"] {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='10'/%3e%3cpolyline points='12,6 12,12 16,14'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 20px 20px;
}

input[type="time"]:hover {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%233E27BE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='10'/%3e%3cpolyline points='12,6 12,12 16,14'/%3e%3c/svg%3e");
}

/* Disabled state for date and time */
input[type="date"]:disabled {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23656565' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3e%3cline x1='16' y1='2' x2='16' y2='6'/%3e%3cline x1='8' y1='2' x2='8' y2='6'/%3e%3cline x1='3' y1='10' x2='21' y2='10'/%3e%3c/svg%3e");
}

input[type="time"]:disabled {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23656565' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='10'/%3e%3cpolyline points='12,6 12,12 16,14'/%3e%3c/svg%3e");
}

input[type="radio"] {
    appearance: none;
    width: 12px !important;
    height: 12px !important;
    border: 1px solid #656565;
    border-radius: 50%;
    background-color: #fff;
    cursor: pointer;
}

input[type="radio"]:checked {
    background-color: #BECCFF;
    border: 5px solid #5C58EB;
}

input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    background-color: #fff;
    border: 1px solid #3E27BE;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
}

input[type="checkbox"]:checked {
    background-color: #5C58EB;
    border: 2px solid #3E27BE;
}

input[type="checkbox"]:checked::after {
    content: '✓';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-size: 12px;
    font-weight: bold;
}

button {
    background: #5C58EB;
    color: white;
    cursor: pointer;
    font-weight: bold;
    font-family: Gluten;
    width: 100%;
    padding: 10px;
}

button:hover {
    background: #3E27BE;
}
`

			document.head.appendChild(styleTag)
		}
	}

	addFormStylesDesktop() {
		// Only add styles once
		if (!document.getElementById("creature-form-styles")) {
			const styleTag = document.createElement("style")
			styleTag.id = "creature-form-styles"

			styleTag.innerHTML = `
			/* Scale all content inside scroll panel - DESKTOP ONLY */


/* Fix checkboxes and radio buttons */
#scroll-panel input[type="checkbox"],
#scroll-panel input[type="radio"] {
    width: calc(1.67 * 20px) !important;
    height: calc(1.67 * 20px) !important;
    min-width: calc(1.67 * 20px) !important;
    min-height: calc(1.67 * 20px) !important;
}

/* Fix button */
#scroll-panel button {
    font-size: 1.67em !important;
}

/* Custom scrollbar styles for the scroll panel */
#scroll-panel::-webkit-scrollbar {
    width: 16px;
    -webkit-appearance: none;
}

#scroll-panel::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
    margin: 2px;
}

#scroll-panel::-webkit-scrollbar-thumb {
    background: #5C58EB;
    border-radius: 8px;
    border: 3px solid #f1f1f1;
    min-height: 40px;
}

#scroll-panel::-webkit-scrollbar-thumb:hover {
    background: #3E27BE;
}

/* Force scrollbar to always be visible on all browsers */
#scroll-panel {
    scrollbar-width: thin;
    scrollbar-color: #5C58EB #f1f1f1;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll !important;
}

/* Ensure scrollbar is always visible (not fading) */
#scroll-panel::-webkit-scrollbar {
    display: block !important;
}

#scroll-panel::-webkit-scrollbar-thumb {
    visibility: visible !important;
}

#scroll-panel::-webkit-scrollbar-track {
    visibility: visible !important;
}

/* Firefox - force always visible */
@-moz-document url-prefix() {
    #scroll-panel {
        scrollbar-width: thin !important;
        overflow-y: scroll !important;
    }
}

/* Consistent box-sizing for all form elements */
#scroll-panel * {
    box-sizing: border-box;
}

input[type="date"]::-webkit-calendar-picker-indicator,
input[type="time"]::-webkit-calendar-picker-indicator {
    background-image: none;
    background-color: transparent;
    cursor: pointer;
    width: 20px;
    height: 20px;
}

input[type="radio"], select, input[type="text"], input[type="date"], input[type="time"], button {
    padding: 8px;
    margin: 5px 0;
    border-radius: 5px;
    border: none;
    outline: none;
    font-size: 16px;
    font-family: Space Grotesk;
}

input[type="text"], select, input[type="date"], input[type="time"] {
    width: 30%;
    background: #fff;
    color: #11044E;
    padding: 10px;
    border: 1px solid #11044E;
}

/* Custom dropdown styling with bigger arrow */
select {
    width: 30%;
    background: #fff;
    color: #11044E;
    padding: 10px;
    border: 1px solid #11044E;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 24px 24px;
    padding-right: 40px;
}

select:hover {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%233E27BE' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
}

select:disabled {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23656565' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
}

/* Custom arrows for date and time inputs */
input[type="date"], input[type="time"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-right: 40px;
}

/* Calendar icon for date input */
input[type="date"] {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3e%3cline x1='16' y1='2' x2='16' y2='6'/%3e%3cline x1='8' y1='2' x2='8' y2='6'/%3e%3cline x1='3' y1='10' x2='21' y2='10'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 20px 20px;
}

input[type="date"]:hover {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%233E27BE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3e%3cline x1='16' y1='2' x2='16' y2='6'/%3e%3cline x1='8' y1='2' x2='8' y2='6'/%3e%3cline x1='3' y1='10' x2='21' y2='10'/%3e%3c/svg%3e");
}

/* Clock icon for time input */
input[type="time"] {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='10'/%3e%3cpolyline points='12,6 12,12 16,14'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 20px 20px;
}

input[type="time"]:hover {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%233E27BE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='10'/%3e%3cpolyline points='12,6 12,12 16,14'/%3e%3c/svg%3e");
}

/* Disabled state for date and time */
input[type="date"]:disabled {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23656565' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3e%3cline x1='16' y1='2' x2='16' y2='6'/%3e%3cline x1='8' y1='2' x2='8' y2='6'/%3e%3cline x1='3' y1='10' x2='21' y2='10'/%3e%3c/svg%3e");
}

input[type="time"]:disabled {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23656565' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='10'/%3e%3cpolyline points='12,6 12,12 16,14'/%3e%3c/svg%3e");
}

input[type="radio"] {
    appearance: none;
    width: 12px !important;
    height: 12px !important;
    border: 1px solid #656565;
    border-radius: 50%;
    background-color: #fff;
    cursor: pointer;
}

input[type="radio"]:checked {
    background-color: #BECCFF;
    border: 5px solid #5C58EB;
}

input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    background-color: #fff;
    border: 1px solid #3E27BE;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
}

input[type="checkbox"]:checked {
    background-color: #5C58EB;
    border: 2px solid #3E27BE;
}

input[type="checkbox"]:checked::after {
    content: '✓';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-size: 12px;
    font-weight: bold;
}

button {
    background: #5C58EB;
    color: white;
    cursor: pointer;
    font-weight: bold;
    font-family: Gluten;
    width: 100%;
    padding: 10px;
}

button:hover {
    background: #3E27BE;
}
`

			document.head.appendChild(styleTag)
		}
	}

	addCreatureInfo(panel, index) {
		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		// Create container
		const itemContainer = document.createElement("div")
		itemContainer.style.display = "flex"
		itemContainer.style.alignItems = "center"
		itemContainer.style.marginBottom = "10px"
		itemContainer.style.backgroundColor = "rgba(62, 39, 190, 0.2)"
		itemContainer.style.width = "100%"
		itemContainer.style.boxSizing = "border-box"

		// Add image wrapper
		const imageWrapper = this.createImageWrapper(index, s)

		// Add creature details
		const detailsContainer = this.createCreatureDetails(index, s)

		// Append to container
		itemContainer.appendChild(imageWrapper)
		itemContainer.appendChild(detailsContainer)

		// Add to panel
		panel.appendChild(itemContainer)
	}

	createImageWrapper(index, s = 1) {
		// Create image wrapper
		const wrapper = document.createElement("div")
		wrapper.style.position = "relative"
		wrapper.style.width = `${100 * s}px`
		wrapper.style.height = `${100 * s}px`
		wrapper.style.marginRight = `${50 * s}px`
		//dbCreature01Thumb
		// Add creature image
		const creatureImage = document.createElement("img")
		creatureImage.src = `assets/images/creatureDBThumbs/dbCreature0${index}thumb.png`
		creatureImage.style.width = "125%"
		creatureImage.style.height = "125%"
		creatureImage.style.position = "absolute"
		creatureImage.style.left = "80%"
		creatureImage.style.top = "50%"
		creatureImage.style.transform = "translate(-50%, -50%)"
		creatureImage.style.objectFit = "contain"

		// Add full view button
		const fullViewButton = this.createFullViewButton(index, s)

		// Add elements to wrapper
		wrapper.appendChild(creatureImage)
		wrapper.appendChild(fullViewButton)

		return wrapper
	}

	createFullViewButton(index, s = 1) {
		const button = document.createElement("button")
		const buttonImage = document.createElement("img")
		buttonImage.src = "assets/images/ui/FullView.png"
		buttonImage.style.width = `${30 * s}px`
		buttonImage.style.height = `${30 * s}px`

		button.appendChild(buttonImage)
		button.style.position = "absolute"
		button.style.left = "120%"
		button.style.top = "80%"
		button.style.transform = "translate(-50%, -50%)"
		button.style.zIndex = "1"
		button.style.background = "transparent"
		button.style.border = "none"
		button.style.outline = "none"
		button.style.padding = "0"

		// Add click handler
		const scene = this
		button.addEventListener("click", () => {
			this.createFullScreenView(index)
		})

		return button
	}

	createCreatureDetails(creatureIndex, s = 1) {
		console.log("CREATURE INDEX: " + creatureIndex)

		const creature = this.creatureData.creatures.find(
			({ index }) => index === creatureIndex,
		)

		// Create container
		const container = document.createElement("div")
		container.style.display = "flex"
		container.style.flexDirection = "column"
		container.style.alignItems = "flex-start"

		// Creature name
		const creatureNameElement = document.createElement("div")
		creatureNameElement.textContent = creature.name
		creatureNameElement.style.color = "#11044E"
		creatureNameElement.style.cssText += `font-size: ${28 * s}px !important`
		creatureNameElement.style.fontWeight = "bold"
		creatureNameElement.style.textAlign = "center"

		// Scientific name
		const scientificNameElement = document.createElement("div")
		scientificNameElement.textContent = creature.scientificName
		scientificNameElement.style.color = "#11044E"
		scientificNameElement.style.cssText += `font-size: ${16 * s}px !important`
		scientificNameElement.style.textAlign = "center"

		// Barcode image
		const barCodeImageElement = document.createElement("img")
		barCodeImageElement.style.pointerEvents = "none"
		if (this.currentPlanet === 1 && this.savedMiniLevel === 6) {
			barCodeImageElement.src = `assets/images/barcodes/NoBarcode.png`
			barCodeImageElement.style.width = "70%"
			barCodeImageElement.style.height = "70%"
		} else {
			barCodeImageElement.src = `assets/images/barcodes/Barcode0${creatureIndex}.png`
			barCodeImageElement.style.width = "70%"
			barCodeImageElement.style.height = "70%"
		}
		if (this.currentPlanet === 3 && this.savedMiniLevel === 10) {
			barCodeImageElement.src = `assets/images/barcodes/BarcodeError.png`
			barCodeImageElement.style.width = "70%"
			barCodeImageElement.style.height = "70%"

			// Make barCodeImageElement interactive
			barCodeImageElement.style.cursor = "pointer" // Shows a pointer cursor on hover
			barCodeImageElement.style.pointerEvents = "auto"
			//this.game.canvas.style.pointerEvents = 'none';
			barCodeImageElement.addEventListener("click", () => {
				// Get reference to the tablet scene
				const tabletScene = this.scene.get("TabletScene")

				destroyTooltip(this)

				console.log("MiniGame!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
				// Define a callback for when the mini-game completes
				const returnToDatabase = () => {
					console.log("Mini-game complete Continue to database")

					this.scene.wake("CreatureDatabase")
					this.scene.resume("CreatureDatabase")
					this.scene.pause("TabletScene")
					// Make sure it's visible
					this.scene.bringToTop("CreatureDatabase")
					this.userData = checkLocalSavedData()
					this.savedLevel = this.userData === null ? 0 : this.userData.userLevel
					this.savedMiniLevel =
						this.userData === null ? 0 : this.userData.userMiniLevel
					this.currentPlanet =
						this.userData === null ? 0 : this.userData.currentPlanet
					this.createDetailScroll(this.resumeCreature)
				}

				// Pass the callback to the tablet scene
				tabletScene.createBarcodeMiniGame(returnToDatabase)

				this.removeScrollPanel()
				// Resume the tablet scene
				tabletScene.scene.resume()

				// Hide database scene (proper way in Phaser)
				this.scene.sleep("CreatureDatabase")

				console.log("Barcode clicked! Starting minigame in tablet scene")
			})
		}
		// Generate button
		const generateButtonElement = document.createElement("button")
		// Determine scale factor based on screen width
		const isMobile = window.innerWidth <= 768
		const mobileScaleFactor = 0.8
		const desktopScaleFactor = 1.21

		const scaleFactor = isMobile ? mobileScaleFactor : desktopScaleFactor

		// Button Styles
		generateButtonElement.style.backgroundImage =
			"url(assets/images/buttons/generateBtn.png)"
		generateButtonElement.style.backgroundSize = "cover"
		generateButtonElement.style.backgroundRepeat = "no-repeat"
		generateButtonElement.style.width = (s * 160).toString() + "px"
		generateButtonElement.style.height = (s * 40).toString() + "px"
		generateButtonElement.style.backgroundColor = "transparent"
		generateButtonElement.textContent = "GENERATE"
		generateButtonElement.style.display = "flex"
		generateButtonElement.style.justifyContent = "center"
		generateButtonElement.style.alignItems = "center"
		generateButtonElement.style.color = "#E5EBFF"
		generateButtonElement.style.fontFamily = "Gluten, sans-serif"
		generateButtonElement.style.cssText += `font-size: ${16 * s}px !important`
		generateButtonElement.style.margin = "10px 0 10px 0"
		generateButtonElement.style.textAlign = "center"
		generateButtonElement.style.cursor = "pointer"
		generateButtonElement.style.borderRadius =
			(s * 10).toString() + "px"
		generateButtonElement.style.opacity = "0.5"
		generateButtonElement.style.pointerEvents = "none"

		if (this.currentPlanet === 1 && this.savedMiniLevel === 6) {
			generateButtonElement.style.opacity = "1"
			generateButtonElement.style.pointerEvents = "auto"
		}

		generateButtonElement.addEventListener("click", () => {
			if (this.currentPlanet === 1 && this.savedMiniLevel === 6) {
				barCodeImageElement.src = `assets/images/barcodes/Barcode0${creatureIndex}.png`
				generateButtonElement.style.opacity = "0.5"
				generateButtonElement.style.pointerEvents = "none"

				this.saveButtonReference.style.opacity = "1"
				this.saveButtonReference.style.pointerEvents = "auto"

				destroyTooltip(this)
			}
			console.log(`Generate button for creature ${creatureIndex} pressed`)
		})

		// Add to container
		container.appendChild(creatureNameElement)
		container.appendChild(scientificNameElement)
		container.appendChild(barCodeImageElement)
		container.appendChild(generateButtonElement)

		return container
	}

	createForm(creatureIndex, isDischarged) {
		const creature = this.creatureData.creatures.find(
			({ index }) => index === creatureIndex,
		)
		const form = document.createElement("form")
		form.style.width = "100%"
		form.style.padding = "10px"

		form.setAttribute("lang", "en-GB")

		// Get current date and time in the format needed for input fields
		const now = new Date()
		const day = String(now.getDate()).padStart(2, '0')
		const month = String(now.getMonth() + 1).padStart(2, '0')
		const year = now.getFullYear()
		const currentDate = `${day}/${month}/${year}`
		const currentTime = now.toTimeString().split(" ")[0].substring(0, 5) // Format: HH:MM

		console.log(
			"Current Planet: " + this.currentPlanet,
			" Saved Mini Level: " + this.savedMiniLevel,
		)
		console.log("FEATURES: " + creature.features)

		// Apply consistent styling for all form controls
		const formFields = document.createElement("div")
		formFields.style.display = "grid"
		formFields.style.gridTemplateColumns = "40% 60%"
		formFields.style.gap = "12px"
		formFields.style.alignItems = "center"
		formFields.style.width = "100%"
		formFields.style.marginBottom = "20px"
		// Set locale for DD/MM/YYYY date format
		formFields.setAttribute("lang", "en-GB")

		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 1) {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:"))
				// formFields.appendChild(
				// 	this.createFormFieldInput(
				// 		"text",
				// 		creature.creatureCode.toString(),
				// 		true,
				// 	),
				// )
				formFields.appendChild(this.createOTPInput(creature.creatureCode.toString(), true))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:"))
				formFields.appendChild(
					this.createFormFieldInput("text", "Fluff Giraffe", true),
				)

				// Add form elements with prefill values and disabled
				formFields.appendChild(this.createFormFieldLabel("Movement Style:"))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						creature.movementStyle.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Turquoise", "Orange", "Pink", "Purple", "Blue", "Yellow"],
						creature.color.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:", true))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						null,
						false,
					),
				)
				console.log("CheckBox Added")
				formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						creature.homePlanet.toString(),
						true,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:"))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, true),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:"))
				formFields.appendChild(
					this.createFormFieldInput("time", currentTime, true),
				)
			} else if (this.savedMiniLevel >= 2 && this.savedMiniLevel <= 5) {
				console.log("Planet01 Creature01")
				this.displaySavedData(creatureIndex, formFields)
			} else if (this.savedMiniLevel === 6) {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:", true))
				//formFields.appendChild(this.createFormFieldInput("text", null, false))
				formFields.appendChild(this.createOTPInput(null, false))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:", true))
				formFields.appendChild(this.createFormFieldInput("text", null, false))

				// Add form elements with prefill values and disabled
				formFields.appendChild(this.createFormFieldLabel("Movement Style:"))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						creature.movementStyle.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Turquoise", "Orange", "Pink", "Purple", "Blue", "Yellow"],
						creature.color.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:"))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						["Horns"],
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						creature.homePlanet.toString(),
						true,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:"))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, true),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:"))
				formFields.appendChild(
					this.createFormFieldInput("time", currentTime, true),
				)
			} else if (this.savedMiniLevel === 8 || this.savedMiniLevel === 9) {
				this.displaySavedData(creatureIndex, formFields)
			} else {

				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:", true))
				//formFields.appendChild(this.createFormFieldInput("text", null, false))
				formFields.appendChild(this.createOTPInput(null, false))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:", true))
				formFields.appendChild(this.createFormFieldInput("text", null, false))

				// Add form elements
				formFields.appendChild(this.createFormFieldLabel("Movement Style:", true))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						null,
						false,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:", true))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Turquoise", "Orange", "Pink", "Purple", "Blue", "Yellow"],
						null,
						false,
					),
				)

				console.log("SelectCreatedHere")

				formFields.appendChild(this.createFormFieldLabel("Features:", true))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						null,
						false,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:", true))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						null,
						false,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:", true))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, false),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:", true))
				formFields.appendChild(
					this.createFormFieldInput("time", currentTime, false),
				)
			}
		}

		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel === 1) {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:", true))
				// formFields.appendChild(
				// 	this.createFormFieldInput("text", "306-748-152-000", false),
				// )
				formFields.appendChild(this.createOTPInput("30676", false))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:"))
				formFields.appendChild(
					this.createFormFieldInput("text", "Jelly Bean", true),
				)

				// Add form elements with prefill values and disabled
				formFields.appendChild(this.createFormFieldLabel("Movement Style:"))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						creature.movementStyle.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:", true))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Turquoise", "Orange", "Pink", "Purple", "Blue", "Yellow"],
						null,
						false,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:"))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						creature.features.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						creature.homePlanet.toString(),
						true,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:"))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, true),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:"))
				formFields.appendChild(
					this.createFormFieldInput("time", currentTime, true),
				)
			} else if (this.savedMiniLevel >= 2 && this.savedMiniLevel < 6) {
				this.displaySavedData(creatureIndex, formFields)
			} else if (this.savedMiniLevel === 6 && creatureIndex === 4) {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:"))
				// formFields.appendChild(
				// 	this.createFormFieldInput(
				// 		"text",
				// 		creature.creatureCode.toString(),
				// 		true,
				// 	),
				// )
				formFields.appendChild(this.createOTPInput(creature.creatureCode.toString(), true))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:"))
				formFields.appendChild(
					this.createFormFieldInput("text", "Waggles", true),
				)

				// Add form elements with prefill values and disabled
				formFields.appendChild(this.createFormFieldLabel("Movement Style:", true))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						null,
						false,
					),
				)
				console.log("Correct creature color: " + creature.color.toString())
				formFields.appendChild(this.createFormFieldLabel("Colour:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Turquoise", "Orange", "Pink", "Purple", "Blue", "Yellow"],
						creature.color.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:"))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						["Tail"],
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:", true))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						null,
						false,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:"))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, true),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:"))
				formFields.appendChild(
					this.createFormFieldInput("time", currentTime, true),
				)
			} else if (this.savedMiniLevel >= 8 && this.savedMiniLevel < 10) {
				this.displaySavedData(creatureIndex, formFields)
			} else if (this.savedMiniLevel === 13 && creatureIndex === 5) {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:"))
				// formFields.appendChild(
				// 	this.createFormFieldInput(
				// 		"text",
				// 		creature.creatureCode.toString(),
				// 		true,
				// 	),
				// )
				formFields.appendChild(this.createOTPInput(creature.creatureCode.toString(), true))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:"))
				formFields.appendChild(
					this.createFormFieldInput("text", "Flappy", true),
				)

				// Add form elements
				formFields.appendChild(this.createFormFieldLabel("Movement Style:"))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						creature.movementStyle.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						[
							"Turquoise",
							"Orange",
							"Pink",
							"Purple",
							"Blue",
							"Yellow",
							"Dark Blue",
						],
						creature.color.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:"))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						creature.features.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						creature.homePlanet.toString(),
						true,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:", true))
				formFields.appendChild(this.createHybridDateInput("date", null, false))

				formFields.appendChild(this.createFormFieldLabel("Time scanned:", true))
				formFields.appendChild(this.createFormFieldInput("time", null, false))
			} else if (this.savedMiniLevel >= 15) {
				console.log("SelectCreatedHere")
				this.displaySavedData(creatureIndex, formFields)
			} else {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:", true))
				formFields.appendChild(this.createFormFieldInput("text", null, false))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:", true))
				formFields.appendChild(this.createFormFieldInput("text", null, false))

				// Add form elements
				formFields.appendChild(this.createFormFieldLabel("Movement Style:", true))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						null,
						false,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:", true))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Turquoise", "Orange", "Pink", "Purple", "Blue", "Yellow"],
						null,
						false,
					),
				)

				console.log("SelectCreatedHere")

				formFields.appendChild(this.createFormFieldLabel("Features:", true))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						null,
						false,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:", true))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						null,
						false,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:", true))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, false),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:", true))
				formFields.appendChild(
					this.createFormFieldInput("time", currentTime, false),
				)
			}
		}

		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel === 3) {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:"))
				formFields.appendChild(this.createOTPInput(creature.creatureCode.toString(), true))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:", true))
				formFields.appendChild(this.createFormFieldInput("text", null, false))

				// Add form elements
				formFields.appendChild(this.createFormFieldLabel("Movement Style:"))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						creature.movementStyle.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:", true))
				formFields.appendChild(
					this.createFormFieldDropdown(
						[
							"Turquoise",
							"Orange",
							"Pink",
							"Purple",
							"Blue",
							"Yellow",
							"Dark Blue",
						],
						null,
						false,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:"))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						creature.features.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						creature.homePlanet.toString(),
						true,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:"))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, true),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:"))
				formFields.appendChild(
					this.createFormFieldInput("time", currentTime, true),
				)
			}
			if (
				this.savedMiniLevel === 5 ||
				this.savedMiniLevel === 6 ||
				this.savedMiniLevel === 7
			) {
				this.displaySavedData(creatureIndex, formFields)
			}
			if (this.savedMiniLevel === 10) {
				this.resumeCreature = creature.index
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:"))
				formFields.appendChild(this.createOTPInput("text", null, true))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:"))
				formFields.appendChild(this.createFormFieldInput("text", "??", true))

				// Add form elements
				formFields.appendChild(this.createFormFieldLabel("Movement Style:"))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						null,
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						[
							"Turquoise",
							"Orange",
							"Pink",
							"Purple",
							"Blue",
							"Yellow",
							"Dark Blue",
						],
						"???",
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:"))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						null,
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						"???",
						true,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:"))
				formFields.appendChild(this.createHybridDateInput("date", null, true))

				formFields.appendChild(this.createFormFieldLabel("Time scanned:"))
				formFields.appendChild(this.createFormFieldInput("time", "???", true))
			}
			if (this.savedMiniLevel === 11) {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:", true))
				formFields.appendChild(this.createOTPInput("text", null, true))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:"))
				formFields.appendChild(
					this.createFormFieldInput("text", "Flambe", true),
				)


				// Add form elements
				formFields.appendChild(this.createFormFieldLabel("Movement Style:"))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						creature.movementStyle.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						[
							"Turquoise",
							"Orange",
							"Pink",
							"Purple",
							"Blue",
							"Yellow",
							"Dark Blue",
						],
						creature.color.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:", true))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						null,
						false,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						creature.homePlanet.toString(),
						true,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:"))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, true),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:"))
				formFields.appendChild(
					this.createFormFieldInput("time", currentTime, true),
				)
			}
			if (this.savedMiniLevel === 13) {
				this.displaySavedData(creatureIndex, formFields)
			}
			if (this.savedMiniLevel === 15) {
				this.displaySavedData(creatureIndex, formFields)
			}
			if (this.savedMiniLevel === 18) {
				// Add creature code input
				formFields.appendChild(this.createFormFieldLabel("Creature Code:"))
				formFields.appendChild(this.createOTPInput(creature.creatureCode.toString(), true))

				// Add nickname input
				formFields.appendChild(this.createFormFieldLabel("Nickname:"))
				formFields.appendChild(
					this.createFormFieldInput("text", "Fluffy fairy", true),
				)

				// Add form elements
				formFields.appendChild(this.createFormFieldLabel("Movement Style:", true))
				formFields.appendChild(
					this.createFormFieldRadioGroup(
						["Stands", "Floats", "Other"],
						"movementOption",
						null,
						false,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Colour:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						[
							"Turquoise",
							"Orange",
							"Pink",
							"Purple",
							"Blue",
							"Yellow",
							"Dark Blue",
						],
						creature.color.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Features:"))
				formFields.appendChild(
					this.createFormFieldCheckboxGroup(
						["Tail", "Horns", "Wings", "None"],
						"featureOption",
						creature.features.toString(),
						true,
					),
				)

				formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
				formFields.appendChild(
					this.createFormFieldDropdown(
						["Hypotherra", "Stratosoma", "Emberon", "Earth"],
						creature.homePlanet.toString(),
						true,
					),
				)

				// Add date/time pickers with current values
				formFields.appendChild(this.createFormFieldLabel("Date scanned:"))
				formFields.appendChild(
					this.createHybridDateInput("date", currentDate, true),
				)

				formFields.appendChild(this.createFormFieldLabel("Time scanned:", true))
				formFields.appendChild(this.createFormFieldInput("time", null, false))
			}
			if (this.savedMiniLevel > 18) {
				this.displaySavedData(creatureIndex, formFields)
			}
		}

		if (isDischarged) {
			this.displaySavedData(creatureIndex, formFields)
			this.activityTab.input.enabled = false
			this.activityTab.alpha = 0.5
		}

		formFields.appendChild(this.createFormFieldLabel("Notes:"))
		formFields.appendChild(this.createFormFieldAttachment())

		form.appendChild(formFields)

		// Add save button in its own container
		const buttonContainer = document.createElement("div")
		buttonContainer.style.display = "flex"
		buttonContainer.style.justifyContent = "center"
		buttonContainer.style.width = "100%"
		buttonContainer.style.marginTop = "15px"

		const saveButton = this.createSaveButton(creature)
		saveButton.style.margin = "0 auto"

		buttonContainer.appendChild(saveButton)
		form.appendChild(buttonContainer)

		return form
	}

	// Helper methods for creating form elements with consistent styling
	createFormFieldLabel(text, required = false) {
		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		const label = document.createElement("label")

		// Create the main text node
		const textNode = document.createTextNode(text)
		label.appendChild(textNode)

		// Add a visible asterisk for required fields
		if (required) {
			const requiredMark = document.createElement("span")
			requiredMark.textContent = " *"
			requiredMark.style.color = "#E74C3C" // Red color for the asterisk
			requiredMark.style.fontWeight = "bold"
			label.appendChild(requiredMark)
		}

		// Rest of your existing styling
		label.style.fontFamily = "Space Grotesk, sans-serif"
		label.style.cssText += `font-size: ${14 * s}px !important`
		label.style.fontWeight = "500"
		label.style.color = "#11044E"
		label.style.textAlign = "left"
		label.style.paddingRight = "2px"

		return label
	}

	createOTPInput(value = null, disabled = false) {
		const container = document.createElement("div");
		container.style.display = "flex";
		container.style.gap = "1%";
		container.style.marginLeft = "-10px";
		container.style.width = "100%";
		container.style.maxWidth = `${280 * this.scaleFactor}px`

		let desktopScale = 1
		if (
			this.sys.game.device.os.desktop ||
			this.sys.game.device.os.laptop
		) {
			desktopScale = 2.5
		}

		const cleanValue = value ? value.toString().replace(/\D/g, '') : '';
		const numInputs = 5;
		const inputs = [];

		for (let i = 0; i < numInputs; i++) {
			const input = document.createElement("input");
			input.type = "text";
			input.inputMode = "numeric";
			input.pattern = "[0-9]*"
			input.maxLength = 1;
			input.style.flex = "1";
			input.style.minWidth = "0";
			input.style.aspectRatio = "1";
			input.style.textAlign = "center";
			//input.style.fontSize = "clamp(16px, 4vw, 20px)";
			input.style.cssText += `font-size: ${20 * desktopScale}px !important`
			input.style.fontFamily = "Space Grotesk, sans-serif";
			//input.style.border = "2px solid #5C58EB";
			//input.style.borderRadius = "12px";
			input.style.border = `${2 * this.scaleFactor}px solid #5C58EB`
			input.style.borderRadius = `${12}px`
			input.style.padding = "0";

			if (cleanValue && cleanValue[i]) {
				input.value = cleanValue[i];
			}

			if (disabled) {
				input.disabled = true;
				input.style.opacity = "0.7";
				input.style.cursor = "not-allowed";
				input.style.backgroundColor = "#C8C8C8";
				input.style.borderColor = "#65656580";
				input.style.borderWidth = "1px";
			}

			if (this.currentPlanet === 2 && this.savedMiniLevel === 1) {
				input.style.border = "2px solid #B50042";
			}

			// Add focus event listener
			input.addEventListener("focus", (e) => {
				if (this.currentPlanet === 2 && this.savedMiniLevel === 1) {
					destroyTooltip(this)
					// Change all inputs to blue when any input is focused
					inputs.forEach(inp => {
						inp.style.border = "2px solid #5C58EB";
					});
				}
			});

			input.addEventListener("input", (e) => {
				e.target.value = e.target.value.replace(/\D/g, '');

				if (e.target.value && i < numInputs - 1) {
					inputs[i + 1].focus();
				}
				// This line is redundant now since focus event handles it
				input.style.border = "2px solid #5C58EB";
			});

			input.addEventListener("keydown", (e) => {
				if (e.key === "Backspace" && !e.target.value && i > 0) {
					inputs[i - 1].focus();
				}
			});

			input.addEventListener("paste", (e) => {
				e.preventDefault();
				const pastedData = e.clipboardData.getData("text").replace(/\D/g, '').slice(0, numInputs);

				for (let j = 0; j < pastedData.length && (i + j) < numInputs; j++) {
					inputs[i + j].value = pastedData[j];
				}

				const nextIndex = Math.min(i + pastedData.length, numInputs - 1);
				inputs[nextIndex].focus();
			});

			inputs.push(input);
			container.appendChild(input);
		}

		container.getValue = () => {
			return inputs.map(input => input.value).join("");
		};

		container.setValue = (val) => {
			const cleanVal = val ? val.toString().replace(/\D/g, '') : '';
			for (let i = 0; i < numInputs; i++) {
				inputs[i].value = cleanVal[i] || '';
			}
		};

		return container;
	}

	createFormFieldInput(type, value = "", disabled = false, required = false) {
		// if (type === "date") {
		// 	return this.createHybridDateInput(value, disabled, required);
		// }
		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		const input = document.createElement("input")
		input.type = type
		input.style.width = "95%"
		input.style.fontFamily = "Space Grotesk, sans-serif"
		input.style.cssText += `font-size: ${17 * s}px !important`
		input.style.padding = "8px"
		input.style.border = "2px solid #5C58EB"
		input.style.borderRadius = "12px"
		input.style.marginRight = "20px"
		input.style.marginLeft = "-10px"

		// Force DD/MM/YYYY format for date inputs
		// Multiple approaches to force DD/MM/YYYY format for date inputs
		// if (type === "date") {
		// 	// Method 1: Set multiple locale attributes
		// 	// input.setAttribute("lang", "en-GB")
		// 	// input.setAttribute("locale", "en-GB")

		// 	// Method 2: Set the document locale if not already set
		// 	if (!document.documentElement.lang) {
		// 		document.documentElement.lang = "en-GB"
		// 	}

		// 	// Method 3: Try setting the HTML lang attribute on the parent container
		// 	const container = input.parentElement || document.body
		// 	if (container) {
		// 		container.setAttribute("lang", "en-GB")
		// 	}
		// }

		if (value) {
			input.value = value
		}

		if (disabled) {
			input.disabled = true
			input.style.opacity = "0.7"
			input.style.cursor = "not-allowed"
			input.style.backgroundColor = "#C8C8C8"
			input.style.borderColor = "#65656580"
			input.style.borderWidth = "1px"
		}

		if (required) {
			input.required = true
			// Optionally add a visual indicator for required fields
			input.style.borderColor = "#3E27BE"
			input.style.borderWidth = "2px"
		}
		if (type === 'date') {

			console.log("Here is our input value ====>", input.value)
		}
		console.log("Here is our input Date creature 3 planet ====>", type)

		// Handle touch events for mobile
		document.addEventListener("touchstart", (event) => {
			if (!input.contains(event.target)) {
				input.blur()
				resetZoom()
			}
		})

		function resetZoom() {
			const viewport = document.querySelector("meta[name=viewport]")
			if (viewport) {
				viewport.content =
					"width=device-width, initial-scale=1.0, maximum-scale=1.0"
				setTimeout(() => {
					viewport.content = "width=device-width, initial-scale=1.0"
				}, 300)
			}
		}

		return input
	}

	createHybridDateInput(type, value = "", disabled = false, required = false) {

		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop;
		const isMobile = !isDesktop;

		const container = document.createElement("div");
		container.style.position = "relative";
		container.style.display = "inline-block";
		container.style.width = "95%";
		container.style.cursor = disabled ? "not-allowed" : "pointer";

		const hiddenInput = document.createElement("input");
		hiddenInput.type = "date";
		hiddenInput.style.position = "absolute";
		hiddenInput.style.top = "0";
		hiddenInput.style.left = "0";
		hiddenInput.style.opacity = "0";
		hiddenInput.style.cursor = "pointer";

		if (isMobile) {
			// Cover the full container so any tap opens the picker natively
			hiddenInput.style.width = "100%";
			hiddenInput.style.height = "100%";
			hiddenInput.style.zIndex = "2";
			hiddenInput.style.pointerEvents = disabled ? "none" : "auto";
		} else {
			// On desktop, tucked out of the way — showPicker() is called by the container click
			hiddenInput.style.width = "1px";
			hiddenInput.style.height = "1px";
			hiddenInput.style.pointerEvents = "none";
			hiddenInput.style.zIndex = "-1";
		}

		// Visible text input — purely decorative, never intercepts clicks
		const visibleInput = document.createElement("input");
		visibleInput.type = "text";
		visibleInput.placeholder = "DD/MM/YYYY";
		visibleInput.readOnly = true;
		visibleInput.style.position = "relative";
		visibleInput.style.zIndex = "1";
		visibleInput.style.pointerEvents = "none";
		visibleInput.style.width = "100%";
		this.dateVisibleInput = visibleInput;

		this.applyInputStyles(visibleInput, disabled, required);

		const rightOffset = isMobile ? -85 * this.scaleFactor : -105 * this.scaleFactor;

		// Calendar icon — decorative only
		const button = document.createElement("button");
		button.type = "button";
		button.innerHTML = `<img src="data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235C58EB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3e%3cline x1='16' y1='2' x2='16' y2='6'/%3e%3cline x1='8' y1='2' x2='8' y2='6'/%3e%3cline x1='3' y1='10' x2='21' y2='10'/%3e%3c/svg%3e" alt="Calendar" style="width: 20px; height: 20px;">`;
		button.style.position = "absolute";
		button.style.right = rightOffset + "px";
		button.style.top = "50%";
		button.style.transform = "translateY(-60%)";
		button.style.border = "none";
		button.style.background = "none";
		button.style.cursor = "pointer";
		button.style.fontSize = "16px";
		button.style.zIndex = "3";
		button.style.pointerEvents = "none";

		if (disabled) {
			button.disabled = true;
			button.style.opacity = "0.7";
			button.style.cursor = "not-allowed";
			button.innerHTML = `<img src="data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23656565' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3e%3cline x1='16' y1='2' x2='16' y2='6'/%3e%3cline x1='8' y1='2' x2='8' y2='6'/%3e%3cline x1='3' y1='10' x2='21' y2='10'/%3e%3c/svg%3e" alt="Calendar" style="width: 20px; height: 20px;">`;
			hiddenInput.disabled = true;
		}

		if (isDesktop && !disabled) {
			container.setAttribute("tabindex", "0");
			container.addEventListener("click", (e) => {
				e.stopPropagation();
				try {
					hiddenInput.showPicker();
				} catch (err) {
					hiddenInput.focus();
					hiddenInput.click();
				}
			});
			container.addEventListener("keydown", (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					try {
						hiddenInput.showPicker();
					} catch (err) {
						hiddenInput.focus();
						hiddenInput.click();
					}
				}
			});
		}

		// When a date is selected, update the visible input
		hiddenInput.addEventListener("change", (e) => {
			if (e.target.value) {
				const [year, month, day] = e.target.value.split("-");
				visibleInput.value = `${day}/${month}/${year}`;
				visibleInput.dispatchEvent(new Event("change", { bubbles: true }));
			}
		});

		// Set initial value
		if (value) {
			if (value.includes("/")) {
				const [day, month, year] = value.split("/");
				hiddenInput.value = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
				visibleInput.value = value;
			} else if (value.includes("-")) {
				hiddenInput.value = value;
				const [year, month, day] = value.split("-");
				visibleInput.value = `${day}/${month}/${year}`;
			}
		}

		container.appendChild(hiddenInput);
		container.appendChild(visibleInput);
		container.appendChild(button);

		container.getValue = () => {
			if (hiddenInput.value) {
				const [year, month, day] = hiddenInput.value.split("-");
				return `${day}/${month}/${year}`;
			}
			return "";
		};

		container.setValue = (val) => {
			if (val.includes("/")) {
				const [day, month, year] = val.split("/");
				hiddenInput.value = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
				visibleInput.value = val;
			}
		};

		return container;
	}
	// Helper functions
	applyInputStyles(input, disabled, required) {

		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		input.style.width = "100%";
		input.style.fontFamily = "Space Grotesk, sans-serif";
		input.style.cssText += `font-size: ${17 * s}px !important`
		input.style.padding = "8px";
		input.style.border = "2px solid #5C58EB";
		input.style.borderRadius = "12px";
		input.style.marginRight = "20px";
		input.style.marginLeft = "-10px";

		if (disabled) {
			input.disabled = true;
			input.style.opacity = "0.7";
			input.style.cursor = "not-allowed";
			input.style.backgroundColor = "#C8C8C8";
			input.style.borderColor = "#65656580";
			input.style.borderWidth = "1px";
		}

		if (required) {
			input.required = true;
			input.style.borderColor = "#3E27BE";
			input.style.borderWidth = "2px";
		}
	}

	createFormFieldCheckboxGroup(
		options,
		groupName,
		defaultSelected = [],
		disabled = false,
	) {

		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		console.log('Creating checkbox group:', groupName, options)
		const container = document.createElement("div")
		container.style.display = "flex"
		container.style.gap = "5px"
		//container.style.marginLeft = "-10px"

		if (disabled) {
			container.style.opacity = "0.7"
			container.style.cursor = "not-allowed"
			//container.style.backgroundColor = "#c8c8c8"
			container.style.padding = "5px"
			container.style.borderRadius = "4px"
		}

		// Store references to all checkboxes for easy access
		const checkboxes = []
		let noneCheckbox = null

		options.forEach((option) => {
			const checkboxLabel = document.createElement("label")
			checkboxLabel.style.display = "flex"
			checkboxLabel.style.alignItems = "center"
			checkboxLabel.style.gap = "7px"
			checkboxLabel.style.cssText += `font-size: ${12 * s}px !important`

			const checkbox = document.createElement("input")
			checkbox.type = "checkbox"
			checkbox.name = groupName
			checkbox.value = option.toLowerCase()
			checkbox.style.scale = "1.3"
			//checkbox.style.backgroundColor = "#f8f8f8"

			if (
				defaultSelected &&
				(defaultSelected.includes(option.toLowerCase()) ||
					defaultSelected.includes(option))
			) {
				checkbox.checked = true
			}

			if (disabled) {
				checkbox.disabled = true
				if (!checkbox.checked) {
					checkbox.style.backgroundColor = "#c8c8c8"
				}
			}

			checkbox.addEventListener('change', (e) => {
				console.log(`Checkbox "${option}" (${groupName}):`, e.target.checked ? 'CHECKED' : 'UNCHECKED')

				if (this.currentPlanet == 1 && this.savedMiniLevel == 1) {

					if (this.scrollPanelRef) {
						this.scrollPanelRef.style.removeProperty('overflow')
						this.scrollPanelRef.style.overflowX = 'hidden'
						this.scrollPanelRef.style.removeProperty('pointer-events')
						this.scrollLocked = false // Unlock the custom scrollbar too
					}

					displayTooltip(this, {
						xPos: this.gameW / 2 + 325 * this.scaleFactor,
						yPos: this.gameH / 2 - 50 * this.scaleFactor,
						type: "mediumChunkyLeftTip",
						scale: 1.2,
						text: "Scroll down and save",
						fontScale: -8,
						xTextOffset: 3,
						yTextOffset: 1,
						wrapWidth: 1.5,
					})
				}

				if (this.tutorialHand) {
					this.tutorialHand.destroy()
				}

				if (this.scrollAnim) {
					this.scrollAnim.setVisible(true)
				}

				if (this.detailsOverlayRef) {
					this.detailsOverlayRef.setAboveOverlay([this.tooltip, this.tooltipText, this.scrollAnim])
				}

				this.setupSaveButtonScrollListener(this.scrollPanelRef)
			})

			// Store reference to checkboxes
			checkboxes.push(checkbox)
			console.log('Added checkbox:', option, 'Total checkboxes:', checkboxes.length)
			if (option.toLowerCase() === 'none') {
				noneCheckbox = checkbox
			}

			checkboxLabel.appendChild(checkbox)
			checkboxLabel.appendChild(document.createTextNode(option))
			container.appendChild(checkboxLabel)
		})

		// Add event listeners to handle None option behavior
		checkboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', function () {
				console.log("Pressed here??????????")
				if (this === noneCheckbox) {
					// If None is selected, uncheck and disable all others
					if (this.checked) {
						checkboxes.forEach((cb) => {
							if (cb !== noneCheckbox && !disabled) {
								cb.checked = false
								cb.disabled = true
								cb.style.opacity = "0.5"
							}
						})
					} else {
						// If None is unchecked, enable all others
						checkboxes.forEach((cb) => {
							if (cb !== noneCheckbox && !disabled) {
								cb.disabled = false
								cb.style.opacity = "1"
							}
						})
					}
				} else {
					// If any other option is selected, uncheck and disable None
					if (this.checked && noneCheckbox && !disabled) {
						console.log("CheckBox pressed")
						noneCheckbox.checked = false
						noneCheckbox.disabled = true
						noneCheckbox.style.opacity = "0.5"
					} else if (!disabled) {
						// If all other options are unchecked, enable None
						const otherOptionsChecked = checkboxes.some((cb) =>
							cb !== noneCheckbox && cb.checked
						)
						if (!otherOptionsChecked && noneCheckbox) {
							noneCheckbox.disabled = false
							noneCheckbox.style.opacity = "1"
						}
					}

					// Re-enable scrolling when any checkbox is changed
					// if (this.currentPlanet == 1 && this.savedMiniLevel == 1) {
					// 	displayTooltip(this, {
					// 		xPos: this.gameW / 2 + 325 * this.scaleFactor,
					// 		yPos: this.gameH / 2 - 50 * this.scaleFactor,
					// 		type: "mediumChunkyLeftTip",
					// 		scale: 1.2,
					// 		text: "Scroll down and save",
					// 		fontScale: -8,
					// 		xTextOffset: 3,
					// 		yTextOffset: 1,
					// 		wrapWidth: 1.5,
					// 	})

					// 	console.log('Re-enabling scroll!')
					// 	this.scrollPanelRef.style.removeProperty('overflow')
					// 	this.scrollPanelRef.style.removeProperty('pointer-events')

					// 	if (this.tutorialHand) {
					// 		this.tutorialHand.destroy()
					// 	}
					// }

				}
			})
		})

		// Apply initial state based on default selections
		if (noneCheckbox && noneCheckbox.checked) {
			checkboxes.forEach((cb) => {
				if (cb !== noneCheckbox && !disabled) {
					cb.disabled = true
					cb.style.opacity = "0.5"
				}
			})
		} else if (checkboxes.some((cb) => cb !== noneCheckbox && cb.checked)) {
			if (noneCheckbox && !disabled) {
				noneCheckbox.disabled = true
				noneCheckbox.style.opacity = "0.5"
			}
		}

		// Test if checkboxes are interactive
		container.addEventListener('click', (e) => {
			console.log('Container clicked:', e.target)
		})

		setTimeout(() => {
			const parentWidth = container.parentElement?.getBoundingClientRect().width
			if (!parentWidth) return
			console.log("Parent Width" + parentWidth)
			container.style.marginLeft = parentWidth < 400 ? "-35px" : "0px"
		}, 100)

		return container
	}

	createFormFieldRadioGroup(
		options,
		groupName,
		defaultSelected = null,
		disabled = false,
	) {
		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		const container = document.createElement("div")
		container.style.display = "flex"
		container.style.gap = "10px"
		container.style.marginLeft = "-15px"

		if (disabled) {
			container.style.opacity = "0.7"
			container.style.cursor = "not-allowed"
			container.style.backgroundColor = "#f8f8f8"
			container.style.padding = "5px"
			container.style.borderRadius = "4px"
		}

		// Store references to all radio buttons for easy access
		const radioButtons = []
		const radioLabels = []
		let noneRadio = null

		options.forEach((option) => {
			const radioLabel = document.createElement("label")
			radioLabel.style.display = "flex"
			radioLabel.style.alignItems = "center"
			radioLabel.style.gap = "4px"
			radioLabel.style.cssText += `font-size: ${12 * s}px !important`

			const radio = document.createElement("input")
			radio.type = "radio"
			radio.name = groupName
			radio.value = option.toLowerCase()

			if (
				defaultSelected &&
				option.toLowerCase() === defaultSelected.toLowerCase()
			) {
				radio.checked = true
			}

			if (disabled) {
				radio.disabled = true
				if (!radio.checked) {
					radio.style.backgroundColor = "#c8c8c8"
				}
			}

			// Store reference to radio buttons and labels
			radioButtons.push(radio)
			radioLabels.push(radioLabel)
			if (option.toLowerCase() === 'none') {
				noneRadio = radio
			}

			radioLabel.appendChild(radio)
			radioLabel.appendChild(document.createTextNode(option))
			container.appendChild(radioLabel)
		})

		// Add event listeners to handle None option behavior
		radioButtons.forEach((radio, index) => {
			radio.addEventListener('change', function () {
				if (this === noneRadio) {
					// If None is selected, disable all others
					if (this.checked) {
						radioButtons.forEach((rb, i) => {
							if (rb !== noneRadio && !disabled) {
								rb.disabled = true
								radioLabels[i].style.backgroundColor = "#5b5b5bff"
							}
						})
					}
				} else {
					// If any other option is selected, disable None
					if (this.checked && noneRadio && !disabled) {
						const noneIndex = radioButtons.indexOf(noneRadio)
						noneRadio.disabled = true
						radioLabels[noneIndex].style.backgroundColor = "#5b5b5bff"
					}
				}
			})
		})

		// Add click event to handle deselection and re-enable options
		radioButtons.forEach((radio, index) => {
			radio.addEventListener('click', function (e) {
				// If clicking on an already selected radio button, deselect it
				if (this.checked && this.dataset.wasChecked === 'true') {
					this.checked = false
					this.dataset.wasChecked = 'false'

					// Re-enable all radio buttons when deselecting
					radioButtons.forEach((rb, i) => {
						if (!disabled) {
							rb.disabled = false
							radioLabels[i].style.backgroundColor = ""
						}
					})
				} else {
					// Mark this radio as checked for next time
					radioButtons.forEach((rb) => {
						rb.dataset.wasChecked = rb.checked ? 'true' : 'false'
					})
				}
			})
		})

		// Apply initial state based on default selection
		if (noneRadio && noneRadio.checked) {
			radioButtons.forEach((rb, i) => {
				if (rb !== noneRadio && !disabled) {
					rb.disabled = true
					radioLabels[i].style.backgroundColor = "#c8c8c8"
				}
			})
		} else if (radioButtons.some((rb) => rb !== noneRadio && rb.checked)) {
			if (noneRadio && !disabled) {
				const noneIndex = radioButtons.indexOf(noneRadio)
				noneRadio.disabled = true
				radioLabels[noneIndex].style.backgroundColor = "#c8c8c8"
			}
		}

		// Set initial dataset values for deselection logic
		radioButtons.forEach((rb) => {
			rb.dataset.wasChecked = rb.checked ? 'true' : 'false'
		})

		return container
	}

	createFormFieldAttachment(
		multiple = false,
		acceptedTypes = "*",
		disabled = true,
		required = false,
		maxFileSize = null, // in MB
	) {
		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		const container = document.createElement("div")
		container.style.position = "relative"
		container.style.width = "95%"
		container.style.marginLeft = "-10px"

		// ADD THIS:
		const isMobileDevice = !(this.sys.game.device.os.desktop || this.sys.game.device.os.laptop)
		const attachFontSize = isMobileDevice ? "16px" : "12px"
		const attachPadding = isMobileDevice ? "12px" : "8px"
		const attachIconSize = isMobileDevice ? "18px" : "14px"

		// Create the file input (hidden)
		const fileInput = document.createElement("input")
		fileInput.type = "file"
		fileInput.style.display = "none"
		fileInput.accept = acceptedTypes
		if (multiple) {
			fileInput.multiple = true
		}
		if (required) {
			fileInput.required = true
		}
		if (disabled) {
			fileInput.disabled = true
		}

		// Create the visual attachment button
		const attachmentButton = document.createElement("div")
		attachmentButton.style.width = "100%"
		attachmentButton.style.fontFamily = "Space Grotesk, sans-serif"
		attachmentButton.style.cssText += `font-size: ${14 * s}px !important`
		attachmentButton.style.padding = attachPadding
		attachmentButton.style.border = required
			? "2px dashed #3E27BE"
			: "2px dashed #65656580"
		attachmentButton.style.borderRadius = "12px"
		attachmentButton.style.backgroundColor = disabled ? "#C8C8C8" : "#fff"
		attachmentButton.style.cursor = disabled ? "not-allowed" : "pointer"
		attachmentButton.style.opacity = disabled ? "0.7" : "1"
		attachmentButton.style.display = "flex"
		attachmentButton.style.alignItems = "center"
		attachmentButton.style.gap = "8px"
		attachmentButton.style.transition = "all 0.2s ease"

		// Add hover effect if not disabled
		if (!disabled) {
			attachmentButton.addEventListener("mouseenter", () => {
				attachmentButton.style.backgroundColor = "#fff"
				attachmentButton.style.borderColor = "#C8C8C8"
			})

			attachmentButton.addEventListener("mouseleave", () => {
				attachmentButton.style.backgroundColor = "#fff"
				attachmentButton.style.borderColor = required ? "#3E27BE" : "#C8C8C8"
			})
		}

		// Create attachment icon (using Unicode paperclip)
		const icon = document.createElement("span")
		icon.textContent = "📎"
		icon.style.fontSize = attachIconSize

		// Create text
		const text = document.createElement("span")
		text.textContent = multiple ? "Add Attachments" : "Add Attachment"
		text.style.color = disabled ? "##656565" : "#333"
		text.style.cssText += `font-size: ${14 * s}px !important`

		// Create file count/info display
		const fileInfo = document.createElement("span")
		fileInfo.style.marginLeft = "auto"
		fileInfo.style.fontSize = "14px"
		fileInfo.style.color = "#C8C8C8"
		fileInfo.style.display = "none"

		attachmentButton.appendChild(icon)
		attachmentButton.appendChild(text)
		attachmentButton.appendChild(fileInfo)

		// Handle click to open file dialog
		attachmentButton.addEventListener("click", () => {
			if (!disabled) {
				fileInput.click()
			}
		})

		// Handle file selection
		fileInput.addEventListener("change", (event) => {
			const files = event.target.files

			if (files.length > 0) {
				// Validate file sizes if maxFileSize is specified
				if (maxFileSize) {
					const oversizedFiles = Array.from(files).filter(
						(file) => file.size > maxFileSize * 1024 * 1024,
					)

					if (oversizedFiles.length > 0) {
						alert(
							`Some files exceed the maximum size limit of ${maxFileSize}MB`,
						)
						fileInput.value = "" // Clear the selection
						return
					}
				}

				// Update display
				if (files.length === 1) {
					fileInfo.textContent = files[0].name
					text.textContent = "Change Attachment"
				} else {
					fileInfo.textContent = `${files.length} files selected`
					text.textContent = "Change Attachments"
				}

				fileInfo.style.display = "block"
				attachmentButton.style.backgroundColor = "#C8C8C8"
				attachmentButton.style.borderColor = "#4CAF50"
				attachmentButton.style.borderStyle = "dashed"
			} else {
				// Reset display
				fileInfo.style.display = "none"
				text.textContent = multiple ? "Add Attachments" : "Add Attachment"
				attachmentButton.style.backgroundColor = "#fff"
				attachmentButton.style.borderColor = required ? "#3E27BE" : "#C8C8C8"
				attachmentButton.style.borderStyle = "dashed"
			}
		})

		// Handle drag and drop
		if (!disabled) {
			attachmentButton.addEventListener("dragover", (event) => {
				event.preventDefault()
				attachmentButton.style.backgroundColor = "#fff"
				attachmentButton.style.borderColor = "#2196F3"
				attachmentButton.style.borderStyle = "dashed"
			})

			attachmentButton.addEventListener("dragleave", () => {
				attachmentButton.style.backgroundColor = "#fff"
				attachmentButton.style.borderColor = required ? "#3E27BE" : "#C8C8C8"
				attachmentButton.style.borderStyle = "dashed"
			})

			attachmentButton.addEventListener("drop", (event) => {
				event.preventDefault()
				const droppedFiles = event.dataTransfer.files

				if (droppedFiles.length > 0) {
					// Set the files to the input
					fileInput.files = droppedFiles

					// Trigger the change event manually
					const changeEvent = new Event("change", { bubbles: true })
					fileInput.dispatchEvent(changeEvent)
				}

				attachmentButton.style.backgroundColor = "#fff"
				attachmentButton.style.borderColor = required ? "#3E27BE" : "#C8C8C8"
				attachmentButton.style.borderStyle = "dashed"
			})
		}

		container.appendChild(fileInput)
		container.appendChild(attachmentButton)

		// Add method to get selected files
		container.getFiles = () => fileInput.files

		// Add method to clear selection
		container.clearFiles = () => {
			fileInput.value = ""
			fileInfo.style.display = "none"
			text.textContent = multiple ? "Add Attachments" : "Add Attachment"
			attachmentButton.style.backgroundColor = "#fff"
			attachmentButton.style.borderColor = required ? "#3E27BE" : "#C8C8C8"
			attachmentButton.style.borderStyle = "dashed"
		}

		return container
	}

	createFormFieldDropdown(options, defaultSelected = null, disabled = false) {

		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		const select = document.createElement("select")
		select.style.width = "95%"
		select.style.fontFamily = "Space Grotesk, sans-serif"
		select.style.cssText += `font-size: ${14 * s}px !important`
		select.style.padding = "8px"
		select.style.border = "2px solid #5C58EB"
		select.style.borderRadius = "12px"
		select.style.marginLeft = "-10px"


		if (disabled) {
			select.disabled = true
			select.style.opacity = "0.7"
			select.style.cursor = "not-allowed"
			select.style.backgroundColor = "#c8c8c8"
			select.style.borderColor = "#65656580"
			select.style.borderWidth = "1px"
		}

		// Add default "Select" option
		const defaultOption = document.createElement("option")
		defaultOption.value = ""
		defaultOption.textContent = "Select"
		defaultOption.disabled = true
		defaultOption.hidden = true
		defaultOption.selected = defaultSelected === null
		select.appendChild(defaultOption)

		options.forEach((option, index) => {
			const optionEl = document.createElement("option")
			optionEl.value = index + 1
			optionEl.textContent = option

			if (
				defaultSelected !== null &&
				((typeof defaultSelected === "number" &&
					index + 1 === defaultSelected) ||
					(typeof defaultSelected === "string" && option === defaultSelected))
			) {
				optionEl.selected = true
			}

			select.appendChild(optionEl)
		})

		if (this.currentPlanet == 2 && this.savedMiniLevel == 1) {
			select.addEventListener('focus', () => {
				destroyTooltip02(this)
			})
		}

		return select
	}

	createSaveButton(creature) {
		// Determine scale factor based on screen width
		const saveButton = document.createElement("button")
		const isMobile = window.innerWidth <= 768
		const mobileScaleFactor = 0.5
		const desktopScaleFactor = 1.2
		const scaleFactor = isMobile ? mobileScaleFactor : desktopScaleFactor

		const isDesktop = this.sys.game.device.os.desktop || this.sys.game.device.os.laptop
		const s = isDesktop ? 2 : 1

		// Button Styles
		saveButton.style.backgroundImage = "url(assets/images/buttons/saveBtn.png)"
		saveButton.style.backgroundSize = "cover"
		saveButton.style.backgroundRepeat = "no-repeat"
		saveButton.style.width = (120 * this.scaleFactor).toString() + "px"
		saveButton.style.minWidth = (120 * this.scaleFactor).toString() + "px"
		saveButton.style.height = (60 * this.scaleFactor).toString() + "px"
		saveButton.style.minHeight = (60 * this.scaleFactor).toString() + "px"
		saveButton.style.backgroundColor = "transparent"
		saveButton.textContent = "SAVE"
		saveButton.style.display = "flex"
		saveButton.style.justifyContent = "center"
		saveButton.style.alignItems = "center"
		saveButton.style.color = "#E5EBFF"
		saveButton.style.fontFamily = "Gluten, sans-serif"
		saveButton.style.cssText += `font-size: ${22 * s}px !important`
		saveButton.style.border = "none"
		saveButton.style.cursor = "pointer"
		saveButton.style.borderRadius = (scaleFactor * 6).toString() + "px"

		saveButton.style.transform =
			"translateX(+" + (scaleFactor * 120).toString() + "px)"

		// Position the button to the far right
		saveButton.style.marginLeft = "auto" // This will push it to the right if in a flex container
		saveButton.style.position = "relative" // Allow for positioning adjustments

		saveButton.addEventListener("click", (event) => {
			// if (this.currentPlanet === 3 && this.savedMiniLevel === 10) {
			// 	return
			// }
			event.preventDefault()
			console.log("save")
			this.verifyCreatureData(creature, saveButton)
			// Future implementation: Add actual save functionality
		})

		if (this.currentPlanet === 1 && this.savedMiniLevel === 6) {
			saveButton.style.opacity = "0.5"
			saveButton.style.pointerEvents = "none"
		}
		if (this.currentPlanet === 3 && this.savedMiniLevel === 3) {
			if (!this.zoomTotalTutorial) {
				saveButton.style.opacity = "0.5"
				saveButton.style.pointerEvents = "none"
			}
			else {
				saveButton.style.opacity = "1"
				saveButton.style.pointerEvents = "auto"
			}

		}
		if (this.currentPlanet === 3 && this.savedMiniLevel === 10) {
			saveButton.style.opacity = "0.5"
			saveButton.style.pointerEvents = "none"
		}
		this.saveButtonReference = saveButton

		return saveButton
	}

	addScrollPanelToGame(panel) {
		// Add to the HTML UI container instead of body
		const htmlContainer = document.getElementById("html-ui-container")
		htmlContainer.appendChild(panel)

		// Position panel correctly using game coordinates directly
		const panelWidth = panel.offsetWidth
		const panelHeight = panel.offsetHeight

		// Set transform origin to top center
		panel.style.transformOrigin = "50% 0"

		// Horizontal positioning - center the panel using game coordinates
		panel.style.left = `${this.safeZoneX + this.safeZoneWidth / 2 - panelWidth / 2}px`

		const isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent,
			)

		if (isMobile) {
			console.log("mobile")
			// Position using game coordinates directly
			panel.style.top = `${this.tabHolder.y + this.tabHolder.height * this.scaleFactor * 0.5}px`
		} else {
			console.log("desktop")
			// Position using game coordinates directly
			panel.style.top = `${this.tabHolder.y + this.tabHolder.height * this.scaleFactor * 0.5}px`
		}

		// Make sure the panel is positioned absolutely
		panel.style.position = "absolute"

		// Add the HTML container sync function
		const syncHTMLContainer = () => {
			const canvas = this.game.canvas
			const htmlContainer = document.getElementById("html-ui-container")
			const gameContainer = document.getElementById("game")

			if (!htmlContainer || !canvas || !gameContainer) return

			// Get canvas and container dimensions
			const canvasRect = canvas.getBoundingClientRect()
			const containerRect = gameContainer.getBoundingClientRect()

			// Calculate the scale factor that Phaser is using
			const scaleX = canvasRect.width / this.game.config.width
			const scaleY = canvasRect.height / this.game.config.height
			const scale = Math.min(scaleX, scaleY)

			// Calculate offset for centering (letterboxing)
			const offsetX = (containerRect.width - (this.game.config.width * scale)) / 2
			const offsetY = (containerRect.height - (this.game.config.height * scale)) / 2

			// Apply the same transform to HTML container
			htmlContainer.style.transform = `scale(${scale}) translate(${offsetX / scale}px, ${offsetY / scale}px)`
			htmlContainer.style.transformOrigin = 'top left'
		}

		// Initial sync
		syncHTMLContainer()
	}

	syncHTMLContainer = () => {
		const canvas = this.game.canvas
		const htmlContainer = document.getElementById("html-ui-container")
		const gameContainer = document.getElementById("game")

		// Get canvas and container dimensions
		const canvasRect = canvas.getBoundingClientRect()
		const containerRect = gameContainer.getBoundingClientRect()

		// Calculate the scale factor that Phaser is using
		const scaleX = canvasRect.width / this.game.config.width
		const scaleY = canvasRect.height / this.game.config.height
		const scale = Math.min(scaleX, scaleY)

		// Calculate offset for centering (letterboxing)
		const offsetX = (containerRect.width - (this.game.config.width * scale)) / 2
		const offsetY = (containerRect.height - (this.game.config.height * scale)) / 2

		// Apply the same transform to HTML container
		htmlContainer.style.transform = `scale(${scale}) translate(${offsetX / scale}px, ${offsetY / scale}px)`
		htmlContainer.style.transformOrigin = 'top left'

		// Update input position after container transform
		//updateInputPosition()
	}

	createFullScreenView(creatureIndex) {
		// Hide scroll panel
		document.getElementById("scroll-panel").style.display = "none"
		document.getElementById("tutorial-scrollbar-container").style.display = "none"

		if (this.tooltip) {
			this.tooltip.setVisible(false)
			this.tooltipText.setVisible(false)
		}

		if (this.tooltip02) {
			this.tooltip02.setVisible(false)
			this.tooltipText02.setVisible(false)
		}
		if (this.indicator) {
			this.indicator.setVisible(false)
		}
		if (this.activityNotificationBell) {
			this.activityNotificationBell.setVisible(false)
		}


		const fullViewBackground = this.add
			.image(
				this.gameW / 2,
				this.appBar.y + 140 * this.scaleFactor,
				`wideContainer`,
			)
			.setScale(this.scaleFactor * 0.9, this.scaleFactor * 1.4)

		const maskBG = this.add
			.image(
				this.gameW / 2,
				this.appBar.y + 140 * this.scaleFactor,
				`wideContainer`,
			)
			.setScale(this.scaleFactor * 0.9, this.scaleFactor * 1.2).setVisible(false)
		let creatureImageString
		if (creatureIndex < 10) {
			creatureImageString = `creature0${creatureIndex}_fed`
		} else {
			creatureImageString = `creature${creatureIndex}_fed`
		}

		// Show full view
		const fullView = this.add
			.image(
				this.gameW / 2,
				this.gameH / 2 + 10 * this.scaleFactor,
				creatureImageString,
			)
			.setScale((this.scaleFactor) * 0.35)

		fullView.mask = new Phaser.Display.Masks.BitmapMask(this, maskBG);

		// Track current zoom level
		let currentZoom = (this.scaleFactor) * 0.35;
		const minZoom = (this.scaleFactor) * 0.25;
		const maxZoom = (this.scaleFactor * 2.0) * 0.25;
		const zoomStep = (this.scaleFactor * 0.1) * 0.25;

		const zoomInButton = this.add
			.image(
				fullView.x + 180 * this.scaleFactor,
				fullView.y + 50 * this.scaleFactor,
				"creatureScaleUpButton",
			)
			.setScale(this.scaleFactor * 0.55)
			.setInteractive()

		const zoomOutButton = this.add
			.image(
				fullView.x + 180 * this.scaleFactor,
				fullView.y + 90 * this.scaleFactor,
				"creatureScaleDownButton",
			)
			.setScale(this.scaleFactor * 0.55)
			.setInteractive()

		zoomInButton.on("pointerdown", () => {
			if (currentZoom < maxZoom) {
				currentZoom += zoomStep;
				fullView.setScale(currentZoom);
				playUISound(this, this.soundManager, "Subtle click 1", 0.15);
				if (!this.zoomInTutorial) {
					this.zoomInTutorial = true
				}
				if (!this.zoomTotalTutorial) {
					this.zoomTotalTutorial = true
					this.saveButtonReference.opacity = "1"
					this.saveButtonReference.pointerEvents = "auto"
					if (this.currentPlanet === 3 && this.savedMiniLevel === 3) {
						displayTooltip(this, {
							xPos: zoomOutButton.x - 100 * this.scaleFactor,
							yPos: zoomOutButton.y - 1 * this.scaleFactor,
							type: "pressToZoomTip",
							scale: 1,
							text: "Press the [b]‘-’[/b] to [b]zoom out[/b].",
							fontScale: -8,
							xTextOffset: 0,
							yTextOffset: -1,
							wrapWidth: 1.1,
						})
					}
				}
			}
		})

		zoomOutButton.on("pointerdown", () => {
			if (currentZoom > minZoom) {
				currentZoom -= zoomStep;
				fullView.setScale(currentZoom);
				playUISound(this, this.soundManager, "Subtle click 1", 0.15);
				if (this.tooltip) {
					this.tooltip.destroy()
					this.tooltipText.destroy()
				}
			}
		})

		if (this.currentPlanet === 3 && this.savedMiniLevel === 3) {
			if (this.tooltip) {
				this.tooltip.destroy()
			}
			if (this.tooltipText) {
				this.tooltipText.destroy()
			}

			if (!this.zoomInTutorial) {
				displayTooltip(this, {
					xPos: zoomInButton.x - 100 * this.scaleFactor,
					yPos: zoomInButton.y - 1 * this.scaleFactor,
					type: "pressToZoomTip",
					scale: 1,
					text: "Press the [b]‘+’[/b] to [b]zoom in[/b].",
					fontScale: -8,
					xTextOffset: 0,
					yTextOffset: -1,
					wrapWidth: 1.1,
				})
			}
		}

		// Add close button
		const closeButton = this.add
			.image(
				fullView.x + 180 * this.scaleFactor,
				fullView.y - 110 * this.scaleFactor,
				"closeButton",
			)
			.setScale(this.scaleFactor * 0.5)
			.setInteractive()

		if (this.currentPlanet === 1 && creatureIndex === 2) {
			fullView.setOrigin(0.5, 0.9)
			fullView.setPosition(
				this.gameW / 2,
				this.gameH / 2 + 90 * this.scaleFactor,
			)
		}

		if (this.currentPlanet === 2 && creatureIndex === 4) {
			fullView.setOrigin(0.5, 0.9)
			fullView.setPosition(
				this.gameW / 2,
				this.gameH / 2 + 90 * this.scaleFactor,
			)
		}

		if (this.currentPlanet === 2 && creatureIndex === 5) {
			fullView.setOrigin(0.5, 0.9)
			fullView.setPosition(
				this.gameW / 2,
				this.gameH / 2 + 90 * this.scaleFactor,
			)
		}

		if (this.currentPlanet === 3 && creatureIndex === 6) {
			fullView.setOrigin(0.5, 0.9)
			fullView.setPosition(
				this.gameW / 2,
				this.gameH / 2 + 90 * this.scaleFactor,
			)
		}

		// Add close handler
		closeButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			fullViewBackground.destroy()
			fullView.destroy()
			closeButton.destroy()
			zoomInButton.destroy()
			zoomOutButton.destroy()

			if (this.tooltip) {
				this.tooltip.setVisible(true)
				this.tooltipText.setVisible(true)
			}

			if (this.tooltip02) {
				this.tooltip02.setVisible(true)
				this.tooltipText02.setVisible(true)
			}

			if (this.indicator) {
				this.indicator.setVisible(true)
			}

			if (this.activityNotificationBell) {
				this.activityNotificationBell.setVisible(true)
			}

			document.getElementById("scroll-panel").style.display = "block"
			document.getElementById("tutorial-scrollbar-container").style.display = "block"

			setTimeout(() => {
				this.saveButtonReference.style.opacity = "1"
				this.saveButtonReference.style.pointerEvents = "auto"
			}, 1000)
		})
	}

	verifyCreatureData(creature, saveButton) {
		console.log("Verifying creature data...")

		// Get form elements
		const form = document.getElementById("scroll-panel").querySelector("form")

		// Get user inputs
		// Find the OTP container (it will be the first div in the form that has the getValue method)
		const formDivs = form.querySelectorAll("div");
		let creatureCodeContainer = null;

		for (let div of formDivs) {
			if (div.getValue) {
				creatureCodeContainer = div;
				break;
			}
		}

		const creatureCode = creatureCodeContainer ? creatureCodeContainer.getValue() : "";

		const nickname = form.querySelectorAll("input[type='text']")[1].value
		//const creatureCode = form.querySelectorAll("input[type='text']")[0].value
		const movementStyle =
			form.querySelector("input[name='movementOption']:checked")?.value || ""
		const colorDropdown = form.querySelectorAll("select")[0]
		const colorValue = colorDropdown.options[colorDropdown.selectedIndex].text
		const planetDropdown = form.querySelectorAll("select")[1]
		const planetValue =
			planetDropdown.options[planetDropdown.selectedIndex].text.toString()

		console.log("Nickname: " + nickname)
		// Get selected features
		const selectedFeatures = []
		form
			.querySelectorAll("input[name='featureOption']:checked")
			.forEach((checkbox) => {
				selectedFeatures.push(checkbox.value)
			})

		// Create validation object
		const validation = {
			creatureCode: {
				value: creatureCode,
				expected: creature.creatureCode.toString(),
				isValid: creatureCode === creature.creatureCode.toString(),
			},
			movementStyle: {
				value: movementStyle,
				expected: creature.movementStyle.toLowerCase(),
				isValid: movementStyle === creature.movementStyle.toLowerCase(),
			},
			colour: {
				value: colorValue,
				expected: creature.color,
				isValid: colorValue === creature.color,
			},
			planet: {
				value: planetValue,
				expected: creature.homePlanet,
				isValid: planetValue === creature.homePlanet,
			},
			features: {
				value: selectedFeatures,
				expected: creature.features,
				isValid: this.compareFeatures(selectedFeatures, creature.features),
			},
		}

		// Log validation results
		console.log("Validation results:", validation)

		// Check if all validations passed
		let allValid = true
		let errorMessages = []

		for (const [key, data] of Object.entries(validation)) {
			if (!data.isValid) {
				allValid = false
				let capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1)
				const capitalizedExpected = String(data.expected)
					.split(",")
					.map((str) => str.trim())
					.map((str) => str.charAt(0).toUpperCase() + str.slice(1))
					.join(", ")

				if (capitalizedKey === "MovementStyle") {
					capitalizedKey = "Movement Style"
				}
				if (capitalizedKey === "CreatureCode") {
					capitalizedKey = "Creature Code"
				}

				errorMessages.push(`- ${capitalizedKey}: ${capitalizedExpected}`)
				console.log("Capitalized Key: " + capitalizedKey + " Capitalized Expected: " + capitalizedExpected)
			}
		}
		// console.log("Date " + form.querySelectorAll("input[type='date']")[0].value)
		// console.log("Time " + form.querySelectorAll("input[type='time']")[0].value)

		const dateInput = form.querySelectorAll("input[type='date']")[0].value

		console.log("Here is our selected Date ====>", dateInput)
		const timeInput = form.querySelectorAll("input[type='time']")[0].value

		if (dateInput === "" || timeInput === "") {
			allValid = false
			errorMessages.push(" - Date and Time entered")
		}

		const nicknameInput = form.querySelectorAll("input[type='text']")[0].value
		if (nicknameInput.trim() === "") {
			allValid = false
			errorMessages.push(" Please enter nickname")
		}

		if (this.currentPlanet === 2 && this.savedMiniLevel === 13) {
		}
		// Show validation result to user
		this.showValidationResult(allValid, errorMessages, creature, saveButton)

		return allValid
	}

	// Case-insensitive version of fillCreatureData
	fillCreatureData(creature) {
		console.log(
			"Filling creature data with case-insensitive matching...",
			creature,
		)

		// Ensure the panel and form exist
		const panel = document.getElementById("scroll-panel")
		if (!panel) {
			console.error("No element with ID 'scroll-panel' found.")
			return
		}
		const form = panel.querySelector("form")
		if (!form) {
			console.error("No <form> element found inside #scroll-panel.")
			return
		}

		// Handle features checkboxes - CASE INSENSITIVE
		const featureCheckboxes = form.querySelectorAll(
			"input[name='featureOption']",
		)
		featureCheckboxes.forEach((checkbox) => {
			checkbox.checked = false
			if (creature.features && Array.isArray(creature.features)) {
				// Convert both to lowercase for case-insensitive comparison
				const lowerCaseFeatures = creature.features.map((f) => f.toLowerCase())
				if (lowerCaseFeatures.includes(checkbox.value.toLowerCase())) {
					checkbox.checked = true
				}
			}
		})

		// Handle date input
		const dateInput = form.querySelector("input[type='date']")
		if (dateInput && !dateInput.disabled) {
			if (creature.date) {
				dateInput.value = creature.date
			} else {
				const now = new Date()
				const year = now.getFullYear()
				const month = String(now.getMonth() + 1).padStart(2, "0")
				const day = String(now.getDate()).padStart(2, "0")
				dateInput.value = `${year}-${month}-${day}`
				this.dateVisibleInput.value = `${day}/${month}/${year}` // Update visible input if using custom date input
			}
		}

		// Handle time input
		const timeInput = form.querySelector("input[type='time']")
		if (timeInput && !timeInput.disabled) {
			if (creature.time) {
				timeInput.value = creature.time
			} else {
				const now = new Date()
				const hours = String(now.getHours()).padStart(2, "0")
				const minutes = String(now.getMinutes()).padStart(2, "0")
				timeInput.value = `${hours}:${minutes}`
			}
		}

		// // Text inputs (nickname, creature code, etc.)
		// const textInputs = form.querySelectorAll("input[type='text']")
		// if (
		// 	textInputs.length >= 1 && !textInputs[0].disabled && creature.nickname
		// ) {
		// 	textInputs[1].value = creature.nickname
		// }
		// if (textInputs.length >= 2 && creature.creatureCode !== undefined) {
		// 	textInputs[0].value = creature.creatureCode.toString()
		// }

		const formDivs = form.querySelectorAll("div");
		let creatureCodeContainer = null;

		for (let div of formDivs) {
			if (div.getValue && div.setValue) {
				creatureCodeContainer = div;
				break;
			}
		}

		if (creatureCodeContainer && creature.creatureCode !== undefined && creature.creatureCode !== null) {
			creatureCodeContainer.setValue(creature.creatureCode.toString());
		}

		// Text inputs (nickname, etc.) - skip the first one since it's now OTP
		const textInputs = form.querySelectorAll("input[type='text']")

		// Movement radio buttons - CASE INSENSITIVE
		const movementRadios = form.querySelectorAll("input[name='movementOption']")
		if (creature.movementStyle) {
			const lowerCaseMovementStyle = creature.movementStyle.toLowerCase()
			movementRadios.forEach((radio) => {
				if (radio.value.toLowerCase() === lowerCaseMovementStyle) {
					radio.checked = true
				}
			})
		}

		// Dropdowns - CASE INSENSITIVE
		const dropdowns = form.querySelectorAll("select")

		// Color dropdown
		if (dropdowns.length >= 1 && creature.color) {
			const lowerCaseColor = creature.color.toLowerCase()
			for (let i = 0; i < dropdowns[0].options.length; i++) {
				if (dropdowns[0].options[i].text.toLowerCase() === lowerCaseColor) {
					dropdowns[0].selectedIndex = i
					break
				}
			}
		}

		// Planet dropdown
		if (dropdowns.length >= 2 && creature.homePlanet) {
			const lowerCasePlanet = creature.homePlanet.toLowerCase()
			for (let i = 0; i < dropdowns[1].options.length; i++) {
				if (dropdowns[1].options[i].text.toLowerCase() === lowerCasePlanet) {
					dropdowns[1].selectedIndex = i
					break
				}
			}
		}

		console.log(
			"Form successfully filled with creature data (case-insensitive matching).",
		)
	}
	compareFeatures(selectedFeatures, creatureFeatures) {
		// Handle case when "None" is selected
		if (
			selectedFeatures.includes("none") &&
			(!creatureFeatures || creatureFeatures.length === 0)
		) {
			return true
		}

		// Handle when creature has no features
		if (!creatureFeatures || creatureFeatures.length === 0) {
			return (
				selectedFeatures.length === 0 ||
				(selectedFeatures.length === 1 && selectedFeatures[0] === "none")
			)
		}

		// Compare features arrays (case insensitive)
		if (selectedFeatures.length !== creatureFeatures.length) {
			return false
		}

		const normalizedSelected = selectedFeatures.map((f) => f.toLowerCase())
		const normalizedExpected = creatureFeatures.map((f) => f.toLowerCase())

		return (
			normalizedSelected.every((f) => normalizedExpected.includes(f)) &&
			normalizedExpected.every((f) => normalizedSelected.includes(f))
		)
	}

	showValidationResult(isValid, errorMessages = [], creature, saveButton) {
		// Remove any existing message
		const existingMessage = document.getElementById("validation-message")
		if (existingMessage) {
			existingMessage.remove()
		}

		if (isValid) {
			destroyTooltip(this)
			destroyTooltip02(this)
			// Get form elements
			const form = document.getElementById("scroll-panel").querySelector("form")

			// Get user inputs
			const nickname = form.querySelectorAll("input[type='text']")[0].value
			creature.nickname = nickname
			const date = form.querySelectorAll("input[type='text']")[0].value
			creature.date = date
			const time = form.querySelectorAll("input[type='time']")[0].value
			creature.time = time
			saveUserCreatureDataLocally(creature)

			let cockpitScene = this.scene.get("CockpitScene")
			if (this.currentPlanet === 2 && this.savedMiniLevel === 13) {
				updateMiniLevel(this.savedMiniLevel)
			}
			if (this.currentPlanet === 3 && this.savedMiniLevel === 3) {
				updateMiniLevel(this.savedMiniLevel)
			}
			if (this.currentPlanet === 3 && this.savedMiniLevel === 11) {
				updateMiniLevel(this.savedMiniLevel)
			}
			if (this.currentPlanet === 3 && this.savedMiniLevel === 18) {
				updateMiniLevel(this.savedMiniLevel)
			}

			playTickAnimation(this, {
				xPos: this.gameW / 2 + 340 * this.scaleFactor,
				yPos: this.gameH / 2 + 110 * this.scaleFactor
			})
			if (this.scrollAnim) {
				this.scrollAnim.setVisible(false)
			}
			saveButton.style.opacity = "0.5"
			saveButton.style.pointerEvents = "none"
			//this.saveOverlayRef.setAboveOverlay([])
			this.time.delayedCall(2500, () => {
				handleGameProgressUpdate(cockpitScene)
				this.cleanupScene()
				this.entryCount = 1
				this.scene.stop("CreatureDatabase")
				this.scene.stop("TabletScene")
				this.scene.stop("TabletUI")
				this.scene.resume("CockpitScene")
			})

		} else {
			// Show error message
			playErrorAnimation(this)
			if (this.scrollAnim) {
				this.scrollAnim.setVisible(false)
			}

			playUISound(this, this.soundManager, "Error3", 0.25)
			const scrollPanel = document.getElementById("scroll-panel")
			scrollPanel.style.display = "none"
			const blueBackground = this.add
				.rectangle(
					0,
					0,
					this.cameras.main.width,
					this.cameras.main.height,
					0x11044e,
				)
				.setOrigin(0, 0)
				.setScrollFactor(0)
				.setDepth(999)
				.setAlpha(0.3)
				.setInteractive({ cursor: "default" })

			let errorHolder = this.add
				.image(
					this.cameras.main.width / 2,
					this.cameras.main.height / 2,
					"wideContainer",
				)
				.setScale(this.scaleFactor * 0.85)
				.setDepth(1000)
			let errorTitle = this.add
				.text(
					errorHolder.x -
					(errorHolder.width / 2) * this.scaleFactor +
					60 * this.scaleFactor,
					errorHolder.y -
					(errorHolder.height / 2) * this.scaleFactor +
					40 * this.scaleFactor,
					"Incorrect/Incomplete entry",
					{
						fontFamily: "Gluten",
						fontSize: this.fontSize - 3 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						resolution: 2,
						fontWeight: "700",
						fontStyle: "bold",
					},
				)
				.setDepth(1000)

			let wrapWidth = 0
			if (this.sys.game.device.os.desktop || this.sys.game.device.os.laptop) {
				wrapWidth = 2
			} else {
				wrapWidth = 1.1
			}

			let errorText = this.add
				.text(
					errorHolder.x -
					(errorHolder.width / 2) * this.scaleFactor +
					60 * this.scaleFactor,
					errorTitle.y + 30 * this.scaleFactor,
					"We have corrected and completed the following information:",
					{
						fontFamily: "Space Grotesk",
						fontSize: this.fontSize - 6 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						resolution: 2,
						fontWeight: "700",
						fontStyle: "bold",

						wordWrap: {
							width:
								errorHolder.width * this.scaleFactor - 50 * this.scaleFactor,
							useAdvancedWrap: true,
						},
					},
				)
				.setDepth(1000)

			console.log("error messages" + errorMessages)

			let errorText2 = this.add
				.text(
					errorHolder.x -
					(errorHolder.width / 2) * this.scaleFactor +
					60 * this.scaleFactor,
					errorTitle.y + 70 * this.scaleFactor,
					errorMessages.join("\n"),
					{
						fontFamily: "Space Grotesk",
						fontSize: this.fontSize - 6 * this.scaleFactor,
						color: "#740CC0",
						align: "left",
						resolution: 2,
						fontWeight: "700",
						fontStyle: "bold",
						wordWrap: {
							width: errorHolder.width * this.scaleFactor,
							useAdvancedWrap: true,
						},
					},
				)
				.setDepth(1000)

			// let errorText2 = this.add.rexBBCodeText(
			// 	errorHolder.x -
			// 	(errorHolder.width / 2) * this.scaleFactor +
			// 	60 * this.scaleFactor,
			// 	errorTitle.y + 70 * this.scaleFactor,
			// 	errorMessages.join("\n"),
			// 	{
			// 		fontFamily: "Space Grotesk",
			// 		fontSize: this.fontSize - 6 * this.scaleFactor,
			// 		color: "#740CC0",
			// 		align: "left",
			// 		resolution: 2,
			// 		fontWeight: "700",					
			// 		wrap: {
			// 			mode: "word",
			// 			width: errorHolder.width * this.scaleFactor,
			// 		},
			// 	},
			// )

			let okBtn = this.add
				.image(
					errorHolder.x +
					(errorHolder.width / 2) * this.scaleFactor -
					100 * this.scaleFactor,
					errorHolder.y +
					(errorHolder.height / 2) * this.scaleFactor -
					60 * this.scaleFactor,
					"okBtn",
				)
				.setInteractive()
				.setScale(this.scaleFactor)
				.setDepth(1000)

			let okBtnText = this.add
				.text(okBtn.x, okBtn.y - 10 * this.scaleFactor, "OK", {
					fontSize: Math.round(this.fontSize + 2 * this.scaleFactor) + "px",
					fill: "#fff",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				})
				.setOrigin(0.5)
				.setDepth(1000)

			okBtn.on("pointerup", () => {
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				errorHolder.destroy()
				errorTitle.destroy()
				errorText.destroy()
				errorText2.destroy()
				okBtn.destroy()
				okBtnText.destroy()
				blueBackground.destroy()

				scrollPanel.style.display = "block"

				setTimeout(() => {
					this.fillCreatureData(creature)
				}, 100)
			})

			if (this.detailsOverlayRef) {
				this.detailsOverlayRef.setAboveOverlay([errorHolder, errorText, errorTitle, errorText2, okBtn, okBtnText])
			}
		}
	}

	saveActivity() {
		console.log("Saving activity data...")

		if (this.tutorialHand) {
			this.tutorialHand.destroy()
		}

		// Get the selected food and amount from the UI elements
		const selectedFood = this.dropdownElement.value
		const selectedAmount = this.numberInputElement.value

		// Get the second food selection if available (may be empty)
		let selectedFood2 = this.dropdownElement2?.value || ""
		let selectedAmount2
		let hasSecondFood

		if (this.currentPlanet < 3) {
			selectedAmount2 = null
			hasSecondFood = null
		}

		if (this.currentPlanet >= 3) {
			selectedAmount2 = this.numberInputElement2?.value || ""
			hasSecondFood = selectedFood2 && selectedAmount2
		}

		if (this.currentPlanet === 3 && this.savedMiniLevel === 15) {
			selectedFood2 = null
			selectedAmount2 = null
			hasSecondFood = selectedFood2 && selectedAmount2
		} else {
		}
		// Get the creature data for the currently selected creature
		const creatureIndex = this.selectedCreatureIndex
		const creature = this.creatureData.creatures.find(
			({ index }) => index === creatureIndex,
		)

		console.log(
			`Selected food: ${selectedFood}, amount: ${selectedAmount}${hasSecondFood
				? `, Selected food2: ${selectedFood2}, amount2: ${selectedAmount2}`
				: ""
			}`,
		)
		console.log("Creature:", creature?.food, creature?.foodAmount)

		if (!creature) {
			console.error("No creature selected or creature data not found")
			return false
		}

		// Check if the creature has food preferences defined
		if (
			!creature.food ||
			!creature.foodAmount ||
			!Array.isArray(creature.food) ||
			!Array.isArray(creature.foodAmount)
		) {
			console.error("Creature food data is missing or invalid")
			return false
		}

		// Create validation objects
		let isValidFood1 = false
		// Only validate food2 if it's provided, otherwise consider it valid
		let isValidFood2 = !hasSecondFood

		let validFoodIndex1 = -1
		let validFoodIndex2 = -1

		// Check if the first food and amount match any valid combination
		for (let i = 0; i < creature.food.length; i++) {
			const food = creature.food[i].toLowerCase()
			const amount = creature.foodAmount[i]

			if (food === selectedFood.toLowerCase() && amount === selectedAmount) {
				isValidFood1 = true
				validFoodIndex1 = i
				break
			}
		}

		// Check second food and amount only if both are provided
		if (hasSecondFood) {
			for (let i = 0; i < creature.food.length; i++) {
				// Skip the food item that was already matched by the first food (can't feed the same food twice)
				if (i === validFoodIndex1) continue

				const food = creature.food[i].toLowerCase()
				const amount = creature.foodAmount[i]

				if (
					food === selectedFood2.toLowerCase() &&
					amount === selectedAmount2
				) {
					isValidFood2 = true
					validFoodIndex2 = i
					break
				}
			}
		}

		// Store correct values for potential correction
		const correctValues = {
			food1:
				validFoodIndex1 >= 0
					? creature.food[validFoodIndex1]
					: creature.food[0],
			amount1:
				validFoodIndex1 >= 0
					? creature.foodAmount[validFoodIndex1]
					: creature.foodAmount[0],
			food2:
				validFoodIndex2 >= 0
					? creature.food[validFoodIndex2]
					: hasSecondFood
						? validFoodIndex1 !== 1
							? creature.food[1]
							: creature.food[0]
						: "",
			amount2:
				validFoodIndex2 >= 0
					? creature.foodAmount[validFoodIndex2]
					: hasSecondFood
						? validFoodIndex1 !== 1
							? creature.foodAmount[1]
							: creature.foodAmount[0]
						: "",
		}

		// Prepare validation results for the first food (always required)
		const validation = {
			food1: {
				value: selectedFood,
				expected: isValidFood1
					? creature.food[validFoodIndex1]
					: creature.food.join(" or "),
				isValid: isValidFood1,
			},
			amount1: {
				value: selectedAmount,
				expected: isValidFood1
					? creature.foodAmount[validFoodIndex1]
					: creature.foodAmount.join(" or "),
				isValid: isValidFood1,
			},
		}

		// Add validation for second food only if provided
		if (hasSecondFood) {
			validation.food2 = {
				value: selectedFood2,
				expected: isValidFood2
					? creature.food[validFoodIndex2]
					: creature.food.join(" or "),
				isValid: isValidFood2,
			}
			validation.amount2 = {
				value: selectedAmount2,
				expected: isValidFood2
					? creature.foodAmount[validFoodIndex2]
					: creature.foodAmount.join(" or "),
				isValid: isValidFood2,
			}
		}

		console.log("Food validation results:", validation)

		// Create error messages if not valid
		let errorMessages = []

		if (!isValidFood1) {
			// Create a list of valid food-amount combinations for the error message
			let validCombinations = []
			for (let i = 0; i < creature.food.length; i++) {
				validCombinations.push(
					`${creature.food[i]} (${creature.foodAmount[i]})`,
				)
			}

			errorMessages.push(`- ${validCombinations.join(", ")}`)
		}

		// Add error message for second food-amount pair only if provided and invalid
		if (hasSecondFood && !isValidFood2) {
			if (errorMessages.length === 0) {
				// Create a list of valid food-amount combinations for the error message
				// Exclude the first valid combination if it exists
				let validCombinations = []
				for (let i = 0; i < creature.food.length; i++) {
					if (i !== validFoodIndex1) {
						// Skip the food that was already matched
						validCombinations.push(
							`${creature.food[i]} (${creature.foodAmount[i]})`,
						)
					}
				}
				errorMessages.push(`- ${validCombinations.join(", ")}`)
			} else {
				//errorMessages.push(`Second food-amount combination is also invalid.`)
			}
		}

		// Final validation result depends on whether we have one or two foods
		const finalIsValid = isValidFood1 && isValidFood2

		// Show validation result to user
		this.showFoodValidationResult(
			finalIsValid,
			errorMessages,
			creatureIndex,
			correctValues,
		)

		return finalIsValid
	}

	showFoodValidationResult(
		isValid,
		errorMessages = [],
		creatureIndex,
		correctValues = null,
	) {
		console.log("Correct Values:", correctValues)
		// Remove any existing message
		const existingMessage = document.getElementById("validation-message")
		if (existingMessage) {
			existingMessage.remove()
		}

		if (isValid) {
			// Skip creating success message, just proceed with game progression
			console.log("Food Logged Successfully...")
			let cockpitScene = this.scene.get("CockpitScene")
			if (this.currentPlanet === 3 && this.savedMiniLevel === 6) {
				console.log("Updating mini level to 7")
				updateMiniLevel(this.savedMiniLevel)
			}
			handleGameProgressUpdate(cockpitScene)

			// Clean up and close scenes
			this.cleanupScene()
			this.entryCount = 1
			this.scene.stop("CreatureDatabase")
			this.scene.stop("TabletScene")
			this.scene.stop("TabletUI")
			this.scene.resume("CockpitScene")
		} else {
			// Show error message
			playUISound(this, this.soundManager, "Error3", 0.25)
			playErrorAnimation(this)
			let errorMessage
			if (this.currentPlanet === 1 && this.savedMiniLevel === 3) {
				errorMessage =
					"We have corrected and completed the following information"
			} else {
				errorMessage =
					"We have corrected and completed the following information:"
			}

			if (this.dropdownElement) this.dropdownElement.style.display = "none"
			if (this.numberInputElement)
				this.numberInputElement.style.display = "none"
			if (this.requiredTextElement)
				this.requiredTextElement.style.display = "none"
			if (this.dropdownElement2) this.dropdownElement2.style.display = "none"
			if (this.numberInputElement2)
				this.numberInputElement2.style.display = "none"
			if (this.requiredTextElement2)
				this.requiredTextElement2.style.display = "none"

			const blueBackground = this.add
				.rectangle(
					0,
					0,
					this.cameras.main.width,
					this.cameras.main.height,
					0x11044e,
				)
				.setOrigin(0, 0)
				.setScrollFactor(0)
				.setDepth(999)
				.setAlpha(0.3)
				.setInteractive({ cursor: "default" })

			let errorHolder = this.add
				.image(
					this.cameras.main.width / 2,
					this.cameras.main.height / 2,
					"wideContainer",
				)
				.setScale(this.scaleFactor * 0.85)
				.setDepth(1000)
			let errorTitle = this.add
				.text(
					errorHolder.x -
					(errorHolder.width / 2) * this.scaleFactor +
					60 * this.scaleFactor,
					errorHolder.y -
					(errorHolder.height / 2) * this.scaleFactor +
					40 * this.scaleFactor,
					"Incorrect/Incomplete entry",
					{
						fontFamily: "Gluten",
						fontSize: this.fontSize - 3 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						resolution: 2,
						fontWeight: "700",
						fontStyle: "bold",
					},
				)
				.setDepth(1000)

			let errorText = this.add
				.text(
					errorHolder.x -
					(errorHolder.width / 2) * this.scaleFactor +
					60 * this.scaleFactor,
					errorTitle.y + 30 * this.scaleFactor,
					errorMessage,
					{
						fontFamily: "Space Grotesk",
						fontSize: this.fontSize - 6 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						resolution: 2,
						fontWeight: "700",
						fontStyle: "bold",

						wordWrap: {
							width:
								errorHolder.width * this.scaleFactor - 50 * this.scaleFactor,
							useAdvancedWrap: true,
						},
					},
				)
				.setDepth(1000)

			console.log("error messages" + errorMessages)

			let errorText2 = this.add
				.text(
					errorHolder.x -
					(errorHolder.width / 2) * this.scaleFactor +
					60 * this.scaleFactor,
					errorTitle.y + 70 * this.scaleFactor,
					errorMessages.join("\n"),
					{
						fontFamily: "Space Grotesk",
						fontSize: this.fontSize - 6 * this.scaleFactor,
						color: "#740CC0",
						align: "left",
						resolution: 2,
						fontWeight: "700",
						fontStyle: "bold",
						wordWrap: {
							width: errorHolder.width * this.scaleFactor,
							useAdvancedWrap: true,
						},
					},
				)
				.setDepth(1000)

			// Instead of hard-coding values, use the correct values from validation
			if (correctValues) {
				// Update dropdown and number inputs with correct values
				if (this.dropdownElement) {
					// Find the option with this value and select it
					const options = this.dropdownElement.options
					for (let i = 0; i < options.length; i++) {
						if (
							options[i].text.toLowerCase() ===
							correctValues.food1.toLowerCase()
						) {
							this.dropdownElement.selectedIndex = i
							break
						}
					}
				}

				if (this.numberInputElement) {
					this.numberInputElement.value = correctValues.amount1
					// this.valueInputCange(this.numberInputElement.value )
				}

				// Handle second food and amount if they exist
				if (
					correctValues.food2 &&
					correctValues.amount2 &&
					this.dropdownElement2 &&
					this.numberInputElement2
				) {
					// Find and select correct food in dropdown
					const options = this.dropdownElement2.options
					for (let i = 0; i < options.length; i++) {
						if (
							options[i].text.toLowerCase() ===
							correctValues.food2.toLowerCase()
						) {
							this.dropdownElement2.selectedIndex = i
							break
						}
					}

					this.numberInputElement2.value = correctValues.amount2
				}
			}

			let okBtn = this.add
				.image(
					errorHolder.x +
					(errorHolder.width / 2) * this.scaleFactor -
					100 * this.scaleFactor,
					errorHolder.y +
					(errorHolder.height / 2) * this.scaleFactor -
					60 * this.scaleFactor,
					"okBtn",
				)
				.setInteractive()
				.setScale(this.scaleFactor)
				.setDepth(1000)

			let okBtnText = this.add
				.text(okBtn.x, okBtn.y - 10 * this.scaleFactor, "OK", {
					fontSize: Math.round(this.fontSize + 2 * this.scaleFactor) + "px",
					fill: "#fff",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				})
				.setOrigin(0.5)
				.setDepth(1000)

			if (this.activityOverlayRef) {
				this.activityOverlayRef.setAboveOverlay([errorHolder, errorText, errorTitle, errorText2, okBtn, okBtnText])
			}

			okBtn.on("pointerup", () => {
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				errorHolder.destroy()
				errorTitle.destroy()
				errorText.destroy()
				errorText2.destroy()
				okBtn.destroy()
				blueBackground.destroy()
				okBtnText.destroy()

				if (this.dropdownElement) this.dropdownElement.style.display = "block"
				if (this.numberInputElement)
					this.numberInputElement.style.display = "block"
				if (this.requiredTextElement)
					this.requiredTextElement.style.display = "block"
				if (this.dropdownElement2) this.dropdownElement2.style.display = "block"
				if (this.numberInputElement2)
					this.numberInputElement2.style.display = "block"
				if (this.requiredTextElement2)
					this.requiredTextElement2.style.display = "block"

				// Auto proceed if it's a specific level where we want to continue regardless
				// if (this.currentPlanet === 1 && this.savedMiniLevel === 3) {
				// 	let cockpitScene = this.scene.get("CockpitScene")
				// 	handleGameProgressUpdate(cockpitScene)

				// 	// Clean up and close scenes
				// 	this.cleanupScene()
				// 	this.scene.stop("CreatureDatabase")
				// 	this.scene.stop("TabletScene")
				// 	this.scene.stop("TabletUI")
				// 	this.scene.resume("CockpitScene")
				// }
			})

		}
	}

	displaySavedData(creatureIndex, formFields) {

		// Destroy any existing form fields
		while (formFields.firstChild) {
			formFields.removeChild(formFields.firstChild);
		}

		const savedCreatures = loadUserCreatureDataLocally()
		//console.log("Saved Creatures: " + savedCreatures);
		const creature = savedCreatures.creatures.find(
			({ index }) => index === creatureIndex,
		)
		console.log(creature)

		// Add creature code input
		formFields.appendChild(this.createFormFieldLabel("Creature Code:"))
		formFields.appendChild(
			//this.createFormFieldInput("text", creature.creatureCode, true),
			this.createOTPInput(creature.creatureCode.toString(), true)
		)

		// Add nickname input
		formFields.appendChild(this.createFormFieldLabel("Nickname:"))
		formFields.appendChild(
			this.createFormFieldInput("text", creature.nickname, true),
		)

		// Add form elements with prefill values and disabled
		formFields.appendChild(this.createFormFieldLabel("Movement Style:"))
		formFields.appendChild(
			this.createFormFieldRadioGroup(
				["Stands", "Floats", "Other"],
				"movementOption",
				creature.movementStyle.toString(),
				true,
			),
		)

		formFields.appendChild(this.createFormFieldLabel("Colour:"))
		formFields.appendChild(
			this.createFormFieldDropdown(
				["Turquoise", "Orange", "Pink", "Purple", "Blue", "Yellow"],
				creature.color.toString(),
				true,
			),
		)

		formFields.appendChild(this.createFormFieldLabel("Features:"))
		formFields.appendChild(
			this.createFormFieldCheckboxGroup(
				["Tail", "Horns", "Wings", "None"],
				"featureOption",
				creature.features,
				true,
			),
		)

		formFields.appendChild(this.createFormFieldLabel("Planet found on:"))
		formFields.appendChild(
			this.createFormFieldDropdown(
				["Hypotherra", "Stratosoma", "Emberon", "Earth"],
				creature.homePlanet.toString(),
				true,
			),
		)

		// const currentDate = creature.date.split("T")[0] // Format: YYYY-MM-DD
		// const currentTime = creature.time.split(" ")[0].substring(0, 5) // Format: HH:MM

		// Safe parsing
		// const currentDate = creature.date.includes("T") ? creature.date.split("T")[0] : creature.date;
		// const currentTime = creature.time.includes(" ") ? creature.time.split(" ")[0].substring(0, 5) : creature.time;

		const now = new Date()
		const currentDate = now.toISOString().split("T")[0] // Format: YYYY-MM-DD
		const currentTime = now.toTimeString().split(" ")[0].substring(0, 5) // Format: HH:MM

		// Add date/time pickers with current values
		formFields.appendChild(this.createFormFieldLabel("Date scanned"))
		formFields.appendChild(this.createHybridDateInput("date", currentDate, true))

		formFields.appendChild(this.createFormFieldLabel("Time scanned"))
		formFields.appendChild(
			this.createFormFieldInput("time", currentTime, true),
		)

		setTimeout(() => {
			this.saveButtonReference.style.opacity = "0.5"
			this.saveButtonReference.style.pointerEvents = "none"
		}, 1000)
	}

	cleanupScene() {
		// Remove all HTML elements
		this.removeScrollPanel()
		this.entryCount = 1
		// Make sure these are removed if they exist
		if (this.dropdownElement) this.dropdownElement.remove()
		if (this.numberInputElement) this.numberInputElement.remove()
		if (this.requiredTextElement) this.requiredTextElement.remove()
		if (this.dropdownElement2) this.dropdownElement2.remove()
		if (this.numberInputElement2) this.numberInputElement2.remove()
		if (this.requiredTextElement2) this.requiredTextElement2.remove()
		if (this.addEntry) this.addEntry.destroy()
		if (this.addEntryText) this.addEntryText.destroy()

		// Remove any other HTML elements that might have been created
		const styles = document.getElementById("creature-form-styles")
		if (styles) styles.remove()
	}
}